import { dispatchFirebase } from './firebase.js';
import html2canvas from 'html2canvas';
import { ICON_SRC, TEXT_SRC } from './assets.js';

window.html2canvas = html2canvas;

// ═══════════════════════════════
//  PIN
// ═══════════════════════════════
var PIN_CODE = "316", pinEntry = "";
function pinPress(v) {
  document.getElementById('pin-error').textContent = "";
  if (v==="del") pinEntry=pinEntry.slice(0,-1);
  else if (v==="clear") pinEntry="";
  else if (pinEntry.length<3) pinEntry+=v;
  for(var i=0;i<3;i++) document.getElementById("d"+i).className="pin-dot"+(i<pinEntry.length?" filled":"");
  if (pinEntry.length===3) {
    if (pinEntry===PIN_CODE) { document.getElementById('pin-screen').style.display="none"; document.getElementById('app').style.display="flex"; initApp(); }
    else { document.getElementById('pin-error').textContent="Incorrect code."; pinEntry=""; setTimeout(function(){ for(var i=0;i<3;i++) document.getElementById("d"+i).className="pin-dot"; },600); }
  }
}
document.addEventListener('keydown', function(e) {
  if (document.getElementById('pin-screen').style.display === 'none') return;
  if (e.key >= '0' && e.key <= '9') pinPress(e.key);
  else if (e.key === 'Backspace') pinPress('del');
  else if (e.key === 'Escape') pinPress('clear');
});

// ═══════════════════════════════
//  STATE
// ═══════════════════════════════
var S = {
  screen:'dashboard', students:[], stuFilter:'All', stuSearch:'', selectedStuID:null,
  attDate:'', attClass:'', attRecords:[],
  tattDate:'', tattRecords:[],
  fees:[], feeFilter:'all', feeMonth:'',
  teachers:[], salary:[], salMonth:'',
  settings:{},
  actCalYear: new Date().getFullYear(), actCalMonth: new Date().getMonth(),
  activityData:[],
  holidays:[],
  rcpItems:[], rcpImages:{ rcp_logo:'/Logos/Horizontal_Play School.png?v=3', rcp_wm:'/Logos/5elements.png', rcp_stamp:'/Logos/Stamp.png' },
  attTrackerYear: new Date().getFullYear(), attTrackerMonth: new Date().getMonth(),
  deployURL: window.location.href.split('?')[0],
  cache: {
    students: null, attendance: null, teacherAtt: null,
    fees: null, teachers: null, activity: null,
    settings: null, nextReceiptNo: null, fetchedAt: null,
    holidays: null
  },
  _trackerInit: false, _staffTab: 'teachers',
  _pendingBulkFeeIDs: [], _pendingBulkStudentName: ''
};

// ═══════════════════════════════
//  HELPERS
// ═══════════════════════════════
function fmtDate(d){
  if(!d) return '—';
  var s=String(d).substring(0,10);
  var p=s.split('-');
  if(p.length<3) return s;
  var months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var m=parseInt(p[1])-1;
  return p[2]+'-'+(months[m]||p[1])+'-'+p[0];
}
function fmtMonth(ym){
  if(!ym) return '—';
  var p=String(ym).split('-');
  var months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var m=parseInt(p[1])-1;
  return (months[m]||p[1])+'-'+p[0];
}
function pad(n){return n<10?'0'+n:''+n;}
function todayVal(){var t=new Date();return t.getFullYear()+'-'+pad(t.getMonth()+1)+'-'+pad(t.getDate());}
function fmt(n){return parseFloat(n||0).toLocaleString('en-IN');}
function toast(msg){var t=document.getElementById('toast');t.textContent=msg;t.classList.add('show');setTimeout(function(){t.classList.remove('show');},2800);}
function closeModal(id){document.getElementById(id).style.display='none';}
function closeModalOutside(e,id){if(e.target.id===id)closeModal(id);}
function copyAttLink(){
  var url=window.location.href.split('?')[0]+'?view=attendance';
  try{navigator.clipboard.writeText(url).then(function(){toast('Student attendance link copied ✓');});}
  catch(e){window.prompt('Copy this link:',url);}
}
function isCamOn(val){
  return val===true||String(val).toLowerCase()==='true'||val==='TRUE';
}
function cmpName(a, b) {
  var nameA = String(a && a.Name ? a.Name : '').trim();
  var nameB = String(b && b.Name ? b.Name : '').trim();
  return nameA.localeCompare(nameB);
}

// ═══════════════════════════════
//  INIT
// ═══════════════════════════════
function initApp() {
  var today = new Date();
  S.attDate = todayVal(); S.tattDate = todayVal();
  document.getElementById('date-str').textContent = today.toLocaleDateString('en-IN',{weekday:'long',year:'numeric',month:'long',day:'numeric'});
  document.getElementById('att-date').value = S.attDate;
  document.getElementById('tatt-date').value = S.tattDate;
  document.getElementById('exit-date').value = S.attDate;
  document.getElementById('fee-date').value = S.attDate;
  document.getElementById('fee-bulk-date').value = S.attDate;
  document.getElementById('rcp-date').value = S.attDate;
  document.getElementById('act-log-date').value = S.attDate;
  populateMonthDropdowns();
  warmCache(function(){ loadDashboard(); });
  document.getElementById('att-date').addEventListener('change', function(){ S.attDate=this.value; loadAttendance(); });
  document.getElementById('tatt-date').addEventListener('change', function(){ S.tattDate=this.value; loadTeacherAttendance(); });
  document.getElementById('act-class-filter').addEventListener('change', renderActivityCalendar);
}

function warmCache(cb, force){
  if(S.cache.fetchedAt && !force){
    applyCache();
    if(cb) cb();
    return;
  }
  setRefreshSpinner(true);
  dispatchFirebase('getAllData', {})
    .then(function(d){
      setRefreshSpinner(false);
      S.cache.students    = d.students    || [];
      S.cache.attendance  = d.attendance  || [];
      S.cache.teacherAtt  = d.teacherAtt  || [];
      S.cache.fees        = d.fees        || [];
      S.cache.teachers    = d.teachers    || [];
      S.cache.activity    = d.activity    || [];
      S.cache.settings    = d.settings    || {};
      S.cache.nextReceiptNo = d.nextReceiptNo || '0518';
      S.cache.fetchedAt   = d.fetchedAt;
      S.cache.holidays    = d.holidays    || [];
      applyCache();
      if(cb) cb();
    })
    .catch(function(err){
      setRefreshSpinner(false);
      toast('Refresh failed: '+(err.message||'unknown error'));
      if(cb) cb();
    });
}

function applyCache(){
  S.students  = (S.cache.students  || []).sort(cmpName);
  S.teachers  = (S.cache.teachers  || []).sort(cmpName);
  S.settings  = S.cache.settings   || {};
  S.fees = (S.cache.fees || []).filter(function(f){ return f.Month === S.feeMonth; });
  var actMonth = S.actCalYear+'-'+pad(S.actCalMonth+1);
  S.activityData = (S.cache.activity || []).filter(function(a){
    return String(a.Date).substring(0,7) === actMonth;
  });
}

function softRefresh(){
  warmCache(function(){
    var id=S.screen;
    if(id==='dashboard')  loadDashboard();
    if(id==='students')   renderStudentList();
    if(id==='attendance') loadAttendance();
    if(id==='fees')       { S.fees=(S.cache.fees||[]).filter(function(f){return f.Month===S.feeMonth;}); renderFees(); }
    if(id==='staff')      { if(S._staffTab==='teachers') loadTeachers(); else if(S._staffTab==='tatt') loadTeacherAttendance(); else loadSalary(); }
    if(id==='activity')   renderActivityCalendar();
    if(id==='holidays')   loadHolidays();
    toast('Data refreshed ✓');
  }, true);
}

function setRefreshSpinner(on){
  var icon=document.getElementById('refresh-icon');
  var btn=document.getElementById('refresh-btn');
  if(!icon||!btn) return;
  if(on){ icon.style.animation='spin360 .7s linear infinite'; btn.disabled=true; }
  else { icon.style.animation=''; btn.disabled=false; }
}
(function(){
  var st=document.createElement('style');
  st.textContent='@keyframes spin360{to{transform:rotate(360deg);}}';
  document.head.appendChild(st);
})();

function populateMonthDropdowns() {
  var months=[], now=new Date();
  for(var i=0;i<12;i++){
    var d=new Date(now.getFullYear(),now.getMonth()-i,1);
    var val=d.getFullYear()+'-'+pad(d.getMonth()+1);
    months.push({val:val,label:d.toLocaleDateString('en-IN',{month:'long',year:'numeric'})});
  }
  ['fees-month','salary-month'].forEach(function(id){
    var sel=document.getElementById(id); if(!sel) return;
    // Clear first to prevent duplicate appends on rebuild
    sel.innerHTML = '';
    months.forEach(function(m,i){ var o=document.createElement('option'); o.value=m.val; o.textContent=m.label; if(i===0) o.selected=true; sel.appendChild(o); });
  });
  S.feeMonth=months[0].val; S.salMonth=months[0].val;
}

// ═══════════════════════════════
//  ROUTING
// ═══════════════════════════════
var screenTitles={dashboard:'Dashboard',students:'Students',attendance:'Attendance',fees:'Fees',receipt:'Fee Receipt',staff:'Staff',activity:'Activity Calendar',holidays:'Holiday List',settings:'Settings'};
var navOrder=['dashboard','students','activity','attendance','fees','receipt','staff','holidays','settings'];

function toggleSidebar(forceState) {
  var sidebar = document.querySelector('.sidebar');
  var overlay = document.getElementById('sidebar-overlay');
  if (!sidebar || !overlay) return;
  var isOpen = sidebar.classList.contains('open');
  var nextState = (typeof forceState === 'boolean') ? forceState : !isOpen;
  if (nextState) {
    sidebar.classList.add('open');
    overlay.style.display = 'block';
  } else {
    sidebar.classList.remove('open');
    overlay.style.display = 'none';
  }
}

function showScreen(id) {
  toggleSidebar(false);
  document.querySelectorAll('.screen').forEach(function(s){s.classList.remove('active');});
  document.querySelectorAll('.nav-item').forEach(function(n){n.classList.remove('active');});
  var sc=document.getElementById('screen-'+id);
  if(sc) sc.classList.add('active');
  var ni=navOrder.indexOf(id);
  var navItems=document.querySelectorAll('.nav-item');
  if(ni>=0&&navItems[ni]) navItems[ni].classList.add('active');
  document.getElementById('screen-title').textContent=screenTitles[id]||id;
  document.getElementById('save-bar').style.display=id==='attendance'?'block':'none';
  document.getElementById('tatt-save-bar').style.display='none';
  document.getElementById('topbar-actions').innerHTML='';
  S.screen=id;
  if(id==='dashboard') loadDashboard();
  if(id==='students')  loadStudents();
  if(id==='attendance') loadAttendance();
  if(id==='fees') loadFees();
  if(id==='receipt') initReceiptBuilder();
  if(id==='staff'){ loadTeachers(); S._staffTab=S._staffTab||'teachers'; }
  if(id==='activity') loadActivityCalendar();
  if(id==='holidays') loadHolidays();
  if(id==='settings') loadSettingsUI();
}

function switchStaffTab(tab){
  S._staffTab=tab;
  ['teachers','tatt','salary'].forEach(function(t){
    document.getElementById('staff-sub-'+t).style.display=t===tab?'block':'none';
    document.getElementById('staff-tab-'+t).className='ftab'+(t===tab?' active':'');
  });
  if(tab==='tatt') loadTeacherAttendance();
  if(tab==='salary') loadSalary();
  if(tab==='teachers') loadTeachers();
}

// ═══════════════════════════════
//  BACKEND CALL BRIDGE
// ═══════════════════════════════
function call(action, payload, cb) {
  dispatchFirebase(action, payload || {})
    .then(function(data) {
      if(cb) cb(null, data);
    })
    .catch(function(err) {
      if(cb) cb(err.message || err || 'Connection error');
    });
}

// ═══════════════════════════════
//  DASHBOARD
// ═══════════════════════════════
function loadDashboard() {
  var today = todayVal();
  var month = S.feeMonth || (today.substring(0,7));

  var students  = S.cache.students  || [];
  var active    = students.filter(function(s){ return s.Status==='Active'; });
  var attData   = S.cache.attendance || [];
  var teachers  = S.cache.teachers  || [];
  var tattData  = S.cache.teacherAtt || [];
  var fees      = S.cache.fees      || [];

  var todayAtt  = attData.filter(function(a){ return String(a.Date).substring(0,10)===today; });
  var present   = todayAtt.filter(function(a){ return a.Status==='Present'; }).length;
  var attPct    = active.length>0 ? Math.round((present/active.length)*100) : 0;

  var monthFees = fees.filter(function(f){ return f.Month===month; });
  var unpaid    = monthFees.filter(function(f){ return f.Status==='Unpaid'; });
  var unpaidAmt = unpaid.reduce(function(s,f){ return s+(parseFloat(f.Amount)||0); }, 0);
  var unpaidIDs = {};
  unpaid.forEach(function(f){ unpaidIDs[f.StudentID]=true; });

  var todayTAtt   = tattData.filter(function(a){ return String(a.Date).substring(0,10)===today; });
  var tPresent    = todayTAtt.filter(function(a){ return a.Status==='Present'; }).length;

  document.getElementById('dash-stats').innerHTML=[
    {icon:'👦',cls:'si-orange',label:'Students',val:active.length,sub:'Active enrolled'},
    {icon:'✅',cls:'si-teal',label:'Attendance',val:attPct+'%',sub:present+' present today'},
    {icon:'₹',cls:'si-red',label:'Fees Pending',val:'₹'+fmt(unpaidAmt),sub:Object.keys(unpaidIDs).length+' students'},
    {icon:'👩‍🏫',cls:'si-green',label:'Teachers',val:tPresent+'/'+teachers.length,sub:'Present today'}
  ].map(function(c){return '<div class="stat-card"><div class="stat-icon-wrap '+c.cls+'">'+c.icon+'</div><div class="stat-label">'+c.label+'</div><div class="stat-value">'+c.val+'</div><div class="stat-sub">'+c.sub+'</div></div>';}).join('');

  var nowMM = today.substring(5,7);
  var nextD = new Date(); nextD.setMonth(nextD.getMonth()+1);
  var nextMM = pad(nextD.getMonth()+1);
  var bdays = active.filter(function(s){
    var bm=String(s.DOB||'').substring(5,7);
    return bm===nowMM||bm===nextMM;
  }).sort(function(a,b){
    return parseInt(String(a.DOB).substring(8,10))-parseInt(String(b.DOB).substring(8,10));
  });
  var bdHTML = bdays.length ? '<div class="bday-strip">'+bdays.map(function(b){
    var dd=String(b.DOB).substring(8,10);
    var mm=String(b.DOB).substring(5,7);
    var isToday=(mm===nowMM&&dd===today.substring(8,10));
    var init=(b.Name || '').split(' ').map(function(w){return w[0]||'';}).slice(0,2).join('').toUpperCase();
    var avCls='bday-avatar'+(isToday?' bday-today bday-cake':'');
    return '<div class="bday-card"><div class="'+avCls+'">'+init+'</div><div class="bday-name">'+(b.Name || '').split(' ')[0]+'</div><div class="bday-date">'+dd+' '+monthAbbr(mm)+'</div></div>';
  }).join('')+'</div>' : '<p style="font-size:11px;color:#8A9E9B;padding:6px 0">No birthdays this month 🎉</p>';
  document.getElementById('dash-birthdays').innerHTML=bdHTML;

  var stuMap={};
  students.forEach(function(s){ stuMap[s.StudentID]=s; });
  var pendingList=Object.keys(unpaidIDs).map(function(sid){
    var s=stuMap[sid]||{};
    return {StudentID:sid,Name:s.Name||'',Class:s.Class||'',Phone:s.Phone||''};
  }).sort(cmpName);

  var pendingCount = pendingList.length;
  var countEl = document.getElementById('dash-pending-count');
  if(countEl) countEl.textContent = pendingCount ? pendingCount+' students' : '';

  var pfHTML = pendingList.length
    ? '<div class="bday-strip">'
      + pendingList.map(function(f){
          var init=(f.Name || '').split(' ').map(function(w){return w[0]||'';}).slice(0,2).join('').toUpperCase();
          var total=unpaid.filter(function(u){return u.StudentID===f.StudentID;}).reduce(function(s,u){return s+(parseFloat(u.Amount)||0);},0);
          return '<div class="fee-strip-card">'
            +'<div class="fee-strip-avatar">'+init+'</div>'
            +'<div class="fee-strip-name">'+(f.Name || '').split(' ')[0]+'</div>'
            +'<div class="fee-strip-class">'+f.Class+'</div>'
            +(f.Phone?'<button class="fee-strip-wa" onclick="onWaReminderClick(this)" data-phone="'+f.Phone+'" data-name="'+(f.Name||'').replace(/"/g, '&quot;')+'" data-amount="'+total+'">📲 WA</button>':'')
            +'</div>';
        }).join('')
      + '</div>'
    : '<p style="font-size:11px;color:#8A9E9B;padding:6px 0">All fees clear 🎉</p>';
  document.getElementById('dash-pending-fees').innerHTML=pfHTML;

  var tattMap={};
  todayTAtt.forEach(function(a){ tattMap[a.TeacherID]=a.Status; });
  var taHTML = teachers.length ? teachers.map(function(t){
    var st=tattMap[t.TeacherID]||'Not Marked';
    var tc=st==='Present'?'tag-present':st==='Leave'?'tag-leave':st==='Half Day'?'tag-halfday':'tag-absent';
    return '<div class="fee-row-sm"><span style="font-weight:700;font-size:12px">'+t.Name+'</span><span class="tag '+tc+'">'+st+'</span></div>';
  }).join('') : '<p style="font-size:11px;color:#8A9E9B">No teachers found.</p>';
  document.getElementById('dash-teacher-att').innerHTML=taHTML;

  if(!S._trackerInit){S._trackerInit=true;initAttTracker();}
}

function monthAbbr(mm){var m=['','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];return m[parseInt(mm)]||'';}

function sendWaReminder(phone, name, amount) {
  var month = document.getElementById('fees-month') ? document.getElementById('fees-month').value : '';
  var msg = 'Dear Parent,\n\nThis is a gentle reminder that the school fee of Rs '+fmt(amount)+' for '+name+' is due'+(month?' for '+fmtMonth(month):'')+'.\n\nPlease make the payment at your earliest convenience.\n\nThank you,\nTiny Detectives School';
  var url = 'https://wa.me/91'+phone+'?text='+encodeURIComponent(msg);
  var a = document.createElement('a');
  a.href = url; a.target = '_blank'; a.rel = 'noopener noreferrer';
  document.body.appendChild(a); a.click();
  setTimeout(function(){ document.body.removeChild(a); }, 100);
}

// ═══════════════════════════════
//  STUDENTS
// ═══════════════════════════════
function loadStudents() {
  if(S.cache.students){
    S.students=(S.cache.students||[]).sort(cmpName);
    renderStudentList();
  } else {
    call('getStudents',{},function(err,data){
      if(err) return toast('Error: '+err);
      S.students=data.sort(cmpName); renderStudentList();
    });
  }
}

var avColors=['av-o','av-t','av-g','av-p'];
var avColorsCss={
  'av-o':'background:#FEF0E7;color:#D97840',
  'av-t':'background:#E5F6F6;color:#3DA8A6',
  'av-g':'background:#E8F5E9;color:#2E7D32',
  'av-p':'background:#F3E5F5;color:#6A1B9A'
};

function renderStudentList() {
  var q = (S.stuSearch||'').toLowerCase().trim();
  var data = S.students.filter(function(s){
    if(q) {
      var matches = (s.Name||'').toLowerCase().includes(q) ||
        (s.FatherGuardianName||'').toLowerCase().includes(q) ||
        (s.Phone||'').includes(q);
      if(S.stuFilter === 'Inactive') return matches && s.Status === 'Inactive';
      return matches && s.Status === 'Active';
    }
    if(S.stuFilter === 'All')      return s.Status === 'Active';
    if(S.stuFilter === 'Inactive') return s.Status === 'Inactive';
    return s.Class === S.stuFilter && s.Status === 'Active';
  });

  document.getElementById('stu-count').textContent=data.length+' student'+(data.length!==1?'s':'');
  if(!data.length){document.getElementById('stu-list-scroll').innerHTML='<p style="padding:12px;font-size:12px;color:#8A9E9B">No students found.</p>';return;}
  var html='<div class="stu-card-grid">'+data.map(function(s,i){
    var init=(s.Name || '').split(' ').map(function(w){return w[0]||'';}).slice(0,2).join('').toUpperCase();
    var hasPhoto = s.Photo;
    var avStyle = hasPhoto ? 'background:transparent;padding:0;overflow:hidden;border:1px solid rgba(0,0,0,0.08);' : avColorsCss[avColors[i%4]];
    var avContent = hasPhoto ? '<img src="'+s.Photo+'" style="width:100%;height:100%;object-fit:cover;border-radius:50%;display:block;">' : init;
    var isSelected=S.selectedStuID===s.StudentID?' selected':'';
    var badge=s.Status==='Inactive'?'<div class="smc-badge"><span class="tag tag-inactive" style="font-size:9px">Alumni</span></div>':'';
    var camBadge=isCamOn(s.CameraSubscribed)?'<span style="font-size:9px;background:#F3E5F5;color:#6A1B9A;border-radius:4px;padding:1px 5px;margin-top:2px;display:inline-block">📷</span>':'';
    return '<div class="stu-mini-card'+isSelected+'" onclick="selectStudent(\''+s.StudentID+'\')">'+
      '<div class="smc-avatar" style="'+avStyle+'">'+avContent+'</div>'+
      '<div class="smc-name">'+s.Name+'</div>'+
      '<div class="smc-meta">'+s.Class+'</div>'+
      camBadge+
      badge+
      '</div>';
  }).join('')+'</div>';
  document.getElementById('stu-list-scroll').innerHTML=html;
}

function filterStudents(cls,el){
  S.stuFilter=cls;
  S.stuSearch='';
  document.getElementById('stu-search-inp').value='';
  document.querySelectorAll('.sct').forEach(function(t){t.classList.remove('active');});
  el.classList.add('active');
  renderStudentList();
}

function searchStudents(q){
  S.stuSearch=q;
  if(S.students.length===0){
    call('getStudents',{},function(err,data){ if(!err){S.students=data;renderStudentList();} });
  } else {
    renderStudentList();
  }
}

function selectStudent(id) {
  S.selectedStuID=id;
  renderStudentList();
  if(!id) {
    document.getElementById('stu-detail-panel').innerHTML='<div class="sdp-empty"><span>👆</span><p style="font-size:13px;font-weight:600">Select a student to view details</p></div>';
    updateMobilePanelVisibility();
    return;
  }
  var s=S.students.find(function(x){return x.StudentID===id;});
  if(!s) return;
  var i=S.students.indexOf(s);
  var init=(s.Name || '').split(' ').map(function(w){return w[0]||'';}).slice(0,2).join('').toUpperCase();
  var hasPhoto = s.Photo;
  var avStyle = hasPhoto ? 'background:transparent;padding:0;overflow:hidden;border:1px solid rgba(0,0,0,0.08);' : avColorsCss[avColors[i%4]];
  var avContent = hasPhoto ? '<img src="'+s.Photo+'" style="width:100%;height:100%;object-fit:cover;border-radius:50%;display:block;">' : init;
  var daysActive=s.JoiningDate?Math.floor((new Date()-new Date(s.JoiningDate))/(1000*60*60*24)):0;

  var backBtn = '<button class="btn btn-outline btn-sm mobile-only-back" onclick="selectStudent(null)" style="display:none; margin-bottom:16px;">⬅ Back to List</button>';

  var html=backBtn+'<div class="sdp-header">'
    +'<div class="sdp-avatar-wrap">'
    +'<div class="sdp-avatar" style="'+avStyle+'">'+avContent+'</div>'
    +'</div>'
    +'<div class="sdp-info">'
    +'<div class="sdp-name">'+s.Name+'</div>'
    +'<div class="sdp-class">'+s.Class+(s.Gender?' · '+s.Gender:'')+'</div>'
    +(s.Status==='Active'?'<div class="sdp-days">🗓 '+daysActive+' days active</div>':'<div style="margin-top:4px"><span class="tag tag-inactive">Alumni</span>'+(s.ExitDate?' · Exited '+s.ExitDate:'')+'</div>')
    +'</div></div>';

  html+='<div class="sdp-section"><div class="sdp-section-title">Details</div>'
    +'<div class="sdp-info-grid">'
    +sdRow('Father/Guardian',s.FatherGuardianName||'—')
    +sdRow("Mother",s.MotherName||'—')
    +sdRow('Primary Phone',s.Phone||'—')
    +sdRow('Secondary',s.Phone2||'—')
    +sdRow('Date of Birth',s.DOB||'—')
    +sdRow('Joining Date',s.JoiningDate||'—')
    +sdRow('Address',s.Address||'—')
    +sdRow('Notes',s.Notes||'—')
    +'</div></div>';

  html+='<div class="sdp-section"><div class="sdp-section-title">Attendance (last 3 months)</div>'
    +'<div id="sdp-att-'+id+'"><div class="loader" style="padding:10px">Loading…</div></div></div>';

  html+='<div class="sdp-section"><div class="sdp-section-title">Fees · '+new Date().toLocaleDateString('en-IN',{month:'long',year:'numeric'})+'</div>'
    +'<div id="sdp-fees-'+id+'"><div class="loader" style="padding:8px">Loading…</div></div>'
    +'<div style="margin-top:8px">'
    +'<div class="camera-toggle">'
    +'<div><div class="ct-label">📷 Camera Subscription</div><div class="ct-desc">₹'+(S.settings.camera_charge||500)+'/month additional charge</div></div>'
    +'<div class="toggle-sw'+(isCamOn(s.CameraSubscribed)?' on':'')+'" id="cam-tog-'+id+'" onclick="toggleCamera(\''+id+'\')"></div>'
    +'</div></div></div>';

  if(s.Status==='Inactive'&&s.ExitReason){
    html+='<div class="sdp-section"><div class="sdp-section-title">Exit Remarks</div>'
      +'<p style="font-size:12px;color:#8A9E9B;padding:6px 0">Reason: '+s.ExitReason+' · '+s.ExitDate+'</p></div>';
  }

  html+='<div class="sdp-section"><div class="sdp-section-title">Override Monthly Fee</div>'
    +'<div style="display:flex;gap:8px;align-items:center">'
    +'<input type="number" id="override-fee-'+id+'" value="'+s.FeeAmount+'" class="inp" style="width:120px">'
    +'<button class="btn btn-outline btn-sm" onclick="updateFeeOverride(\''+id+'\')">Update</button>'
    +'</div></div>';

  html+='<div class="sdp-actions">';
  html+='<button class="btn btn-outline btn-sm" onclick="openEditStudent(\''+s.StudentID+'\')">✏️ Edit</button>';
  html+='<button class="btn btn-wa btn-sm" onclick="onWaReminderClick(this)" data-phone="'+s.Phone+'" data-name="'+(s.Name||'').replace(/"/g, '&quot;')+'" data-amount="'+s.FeeAmount+'" title="WhatsApp">📲 WhatsApp</button>';
  html+='<button class="btn btn-outline btn-sm" onclick="openGenerateReceipt(\''+s.StudentID+'\')">🧾 Receipt</button>';
  html+='<button class="btn btn-outline btn-sm" onclick="openCreateICard(\''+s.StudentID+'\')">🪪 Create iCard</button>';
  if(s.Status==='Active'){
    html+='<button class="btn btn-outline btn-sm" onclick="openPromote(\''+s.StudentID+'\')">🎓 Promote</button>';
    html+='<button class="btn btn-danger btn-sm" style="margin-left:auto" onclick="openExitModal(\''+s.StudentID+'\')">Exit</button>';
  }
  html+='</div>';

  document.getElementById('stu-detail-panel').innerHTML=html;

  call('getAttendanceHistory',{studentID:id},function(err,data){
    var el=document.getElementById('sdp-att-'+id);
    if(!el) return;
    if(err||!data||!data.length){el.innerHTML='<p style="font-size:11px;color:#8A9E9B">No attendance records yet.</p>';return;}
    el.innerHTML=data.map(function(m){
      var pct=m.total>0?Math.round((m.present/m.total)*100):0;
      var d=new Date(m.month+'-01');
      return '<div class="att-month-row">'
        +'<div class="att-month-label">'+d.toLocaleDateString('en-IN',{month:'short',year:'2-digit'})+'</div>'
        +'<div class="att-bar"><div class="att-bar-fill" style="width:'+pct+'%"></div></div>'
        +'<div class="att-stats">'+m.present+'/'+m.total+' ('+pct+'%)</div>'
        +'</div>';
    }).join('');
  });

  call('getStudentFees',{studentID:id},function(err,data){
    var el=document.getElementById('sdp-fees-'+id);
    if(!el) return;
    if(err||!data||!data.length){el.innerHTML='<p style="font-size:11px;color:#8A9E9B">No fee records for this month. Generate fees first.</p>';return;}
    el.innerHTML=data.map(function(f){
      var typeCls='tag-'+(f.FeeType||'monthly').toLowerCase();
      return '<div class="fee-detail-row">'
        +'<div class="fdr-left"><div class="fdr-type"><span class="tag '+typeCls+'" style="font-size:9px">'+(f.FeeType||'Monthly')+'</span></div>'
        +'<div class="fdr-sub">'+(f.Status==='Paid'?'Paid on '+f.PaymentDate:'Due')+'</div></div>'
        +'<div class="fdr-amount">₹'+fmt(f.Amount)+'</div>'
        +(f.Status==='Unpaid'?'<button class="btn btn-sm btn-primary" onclick="openMarkFeePaid(\''+f.FeeID+'\')">Mark Paid</button>':'<span class="tag tag-paid">Paid</span>')
        +'</div>';
    }).join('');
  });

  updateMobilePanelVisibility();
}

function updateMobilePanelVisibility() {
  if (window.innerWidth <= 900) {
    const listPanel = document.querySelector('.stu-list-panel');
    const detailPanel = document.getElementById('stu-detail-panel');
    if (!listPanel || !detailPanel) return;
    
    if (S.selectedStuID) {
      listPanel.style.display = 'none';
      detailPanel.style.display = 'block';
    } else {
      listPanel.style.display = 'flex';
      detailPanel.style.display = 'none';
    }
  } else {
    const listPanel = document.querySelector('.stu-list-panel');
    const detailPanel = document.getElementById('stu-detail-panel');
    if (listPanel) listPanel.style.display = '';
    if (detailPanel) detailPanel.style.display = '';
  }
}

function sdRow(label,val){return '<div class="sdp-info-row"><div class="sdp-info-label">'+label+'</div><div class="sdp-info-val">'+val+'</div></div>';}

let cropImg = null;
let cropZoom = 1;
let cropRotation = 0;
let cropPanX = 0;
let cropPanY = 0;
let isDraggingCrop = false;
let startDragX = 0;
let startDragY = 0;

function handleModalPhotoUpload(e) {
  const file = e.target.files[0];
  if (!file) return;
  if (!file.type.startsWith('image/')) { toast('⚠️ Invalid image format'); return; }
  const reader = new FileReader();
  reader.onload = ev => {
    cropImg = new Image();
    cropImg.onload = () => {
      cropZoom = 1;
      cropRotation = 0;
      cropPanX = 0;
      cropPanY = 0;
      document.getElementById('crop-zoom-slider').value = 1;
      document.getElementById('crop-placeholder').style.display = 'none';
      document.getElementById('crop-canvas').style.display = 'block';
      document.getElementById('crop-controls').style.display = 'flex';
      drawCroppedImage();
    };
    cropImg.src = ev.target.result;
  };
  reader.readAsDataURL(file);
}

function drawCroppedImage() {
  if (!cropImg) return;
  const canvas = document.getElementById('crop-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  
  canvas.width = 240;
  canvas.height = 280;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  
  ctx.save();
  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.rotate((cropRotation * Math.PI) / 180);
  
  const isRotated90 = (cropRotation % 180) !== 0;
  const viewW = isRotated90 ? canvas.height : canvas.width;
  const viewH = isRotated90 ? canvas.width : canvas.height;
  
  const scaleX = viewW / cropImg.width;
  const scaleY = viewH / cropImg.height;
  const baseScale = Math.max(scaleX, scaleY);
  
  const zoomSlider = document.getElementById('crop-zoom-slider');
  const zoomVal = zoomSlider ? parseFloat(zoomSlider.value) : 1;
  const finalScale = baseScale * zoomVal;
  
  let px = cropPanX * 2;
  let py = cropPanY * 2;
  
  ctx.translate(px, py);
  ctx.scale(finalScale, finalScale);
  ctx.drawImage(cropImg, -cropImg.width / 2, -cropImg.height / 2);
  ctx.restore();
}

function rotateModalPhoto() {
  cropRotation = (cropRotation + 90) % 360;
  drawCroppedImage();
}

function deleteModalPhoto() {
  cropImg = null;
  const canvas = document.getElementById('crop-canvas');
  if (canvas) canvas.style.display = 'none';
  document.getElementById('crop-placeholder').style.display = 'block';
  document.getElementById('crop-controls').style.display = 'none';
  document.getElementById('modal-stu-photo-input').value = '';
}

function getCroppedPhotoData() {
  if (!cropImg) return "";
  const canvas = document.getElementById('crop-canvas');
  return canvas ? canvas.toDataURL('image/jpeg', 0.8) : "";
}

function initCropDragging() {
  const viewport = document.getElementById('modal-crop-viewport');
  if (!viewport) return;
  
  const startDrag = (x, y) => {
    if (!cropImg) return;
    isDraggingCrop = true;
    startDragX = x - cropPanX;
    startDragY = y - cropPanY;
  };
  
  const moveDrag = (x, y) => {
    if (!isDraggingCrop) return;
    cropPanX = x - startDragX;
    cropPanY = y - startDragY;
    drawCroppedImage();
  };
  
  const endDrag = () => {
    isDraggingCrop = false;
  };
  
  viewport.addEventListener('mousedown', e => {
    e.preventDefault();
    startDrag(e.clientX, e.clientY);
  });
  
  window.addEventListener('mousemove', e => {
    if (isDraggingCrop) {
      e.preventDefault();
      moveDrag(e.clientX, e.clientY);
    }
  });
  
  window.addEventListener('mouseup', endDrag);
  
  viewport.addEventListener('touchstart', e => {
    if (e.touches.length === 1) {
      startDrag(e.touches[0].clientX, e.touches[0].clientY);
    }
  }, { passive: true });
  
  viewport.addEventListener('touchmove', e => {
    if (isDraggingCrop && e.touches.length === 1) {
      moveDrag(e.touches[0].clientX, e.touches[0].clientY);
    }
  }, { passive: true });
  
  viewport.addEventListener('touchend', endDrag);
}

function openAddStudent(){
  document.getElementById('modal-stu-title').textContent='Add Student';
  document.getElementById('stu-is-edit').value='';
  document.getElementById('stu-id').value='';
  document.getElementById('stu-id').readOnly=false;
  ['stu-name','stu-father','stu-mother','stu-phone','stu-phone2','stu-address','stu-notes'].forEach(function(id){document.getElementById(id).value='';});
  document.getElementById('stu-dob').value='';document.getElementById('stu-class').value='';document.getElementById('stu-gender').value='';document.getElementById('stu-fee').value='';document.getElementById('stu-joining').value=todayVal();
  deleteModalPhoto();
  document.getElementById('modal-student').style.display='flex';
}
function prefillFee(){
  var cls=document.getElementById('stu-class').value;
  var km={'Pre-Nursery':'fee_prenursery','Nursery':'fee_nursery','LKG':'fee_lkg'};
  var k=km[cls]; if(k&&S.settings[k]) document.getElementById('stu-fee').value=S.settings[k];
}
function openEditStudent(id){
  var s=S.students.find(function(x){return x.StudentID===id;});
  if(!s) return;
  document.getElementById('modal-stu-title').textContent='Edit Student';
  document.getElementById('stu-is-edit').value='true';
  document.getElementById('stu-id').value=s.StudentID;
  document.getElementById('stu-id').readOnly=false;
  document.getElementById('stu-name').value=s.Name;
  document.getElementById('stu-dob').value=s.DOB;
  document.getElementById('stu-class').value=s.Class;
  document.getElementById('stu-gender').value=s.Gender||'';
  document.getElementById('stu-joining').value=s.JoiningDate||'';
  document.getElementById('stu-father').value=s.FatherGuardianName||'';
  document.getElementById('stu-mother').value=s.MotherName||'';
  document.getElementById('stu-phone').value=s.Phone;
  document.getElementById('stu-phone2').value=s.Phone2||'';
  document.getElementById('stu-address').value=s.Address||'';
  document.getElementById('stu-fee').value=s.FeeAmount;
  document.getElementById('stu-notes').value=s.Notes||'';
  
  deleteModalPhoto();
  if (s.Photo) {
    cropImg = new Image();
    cropImg.onload = () => {
      cropZoom = 1;
      cropRotation = 0;
      cropPanX = 0;
      cropPanY = 0;
      document.getElementById('crop-zoom-slider').value = 1;
      document.getElementById('crop-placeholder').style.display = 'none';
      document.getElementById('crop-canvas').style.display = 'block';
      document.getElementById('crop-controls').style.display = 'flex';
      drawCroppedImage();
    };
    cropImg.src = s.Photo;
  }
  
  document.getElementById('modal-student').style.display='flex';
}
function saveStudent(){
  var isEdit=document.getElementById('stu-is-edit').value==='true';
  var id=document.getElementById('stu-id').value.trim();
  var phone=document.getElementById('stu-phone').value.replace(/\D/g,'');
  if(phone.length>0&&phone.length!==10){toast('Phone must be 10 digits');return;}
  var payload={
    StudentID:id,
    oldStudentID:S.selectedStuID,
    Name:document.getElementById('stu-name').value.trim(),
    DOB:document.getElementById('stu-dob').value,Class:document.getElementById('stu-class').value,
    Gender:document.getElementById('stu-gender').value,
    FatherGuardianName:document.getElementById('stu-father').value.trim(),
    MotherName:document.getElementById('stu-mother').value.trim(),
    Phone:phone,Phone2:document.getElementById('stu-phone2').value.replace(/\D/g,''),
    Address:document.getElementById('stu-address').value.trim(),
    JoiningDate:document.getElementById('stu-joining').value,
    FeeAmount:parseFloat(document.getElementById('stu-fee').value)||0,
    Notes:document.getElementById('stu-notes').value.trim(),
    Photo: getCroppedPhotoData()
  };
  if(!payload.Name||!payload.Class||!payload.Phone) return toast('Name, Class and Phone required');
  call(isEdit?'updateStudent':'addStudent',payload,function(err){
    if(err) return toast('Error: '+err);
    closeModal('modal-student');toast(isEdit?'Updated ✓':'Student added ✓');
    S.cache.students=null; S.cache.fees=null;
    loadStudents();
  });
}
function openPromote(id){
  if(!confirm('Promote this student to the next class?')) return;
  call('promoteStudent',{StudentID:id},function(err,d){
    if(err) return toast('Error: '+err);
    toast('Promoted to '+d.newClass+' ✓');S.cache.students=null;loadStudents();
  });
}
function openExitModal(id){document.getElementById('exit-id').value=id;document.getElementById('modal-exit').style.display='flex';}
function confirmExit(){
  call('exitStudent',{StudentID:document.getElementById('exit-id').value,ExitDate:document.getElementById('exit-date').value,ExitReason:document.getElementById('exit-reason').value},function(err){
    if(err) return toast('Error: '+err);
    closeModal('modal-exit');toast('Student exited ✓');S.cache.students=null;loadStudents();
  });
}
function updateFeeOverride(id){
  var amt=parseFloat(document.getElementById('override-fee-'+id).value);
  if(!amt) return toast('Enter valid amount');
  call('updateStudentFee',{studentID:id,feeAmount:amt},function(err){
    if(err) return toast('Error: '+err);
    toast('Fee updated ✓');loadStudents();
  });
}
function toggleCamera(id){
  call('toggleCameraCharge',{studentID:id},function(err,d){
    if(err) return toast('Error: '+err);
    var tog=document.getElementById('cam-tog-'+id);
    if(tog){ if(d.subscribed) tog.classList.add('on'); else tog.classList.remove('on'); }
    toast(d.subscribed?'Camera charge enabled ✓':'Camera charge disabled');
    var stu = S.students.find(function(x){ return x.StudentID===id; });
    if(stu) stu.CameraSubscribed = d.subscribed;
    if(S.cache.students){
      var cstu = S.cache.students.find(function(x){ return x.StudentID===id; });
      if(cstu) cstu.CameraSubscribed = d.subscribed;
    }
    S.cache.fees=null;
  });
}
function openGenerateReceipt(id){
  showScreen('receipt');
  setTimeout(function(){
    var sel=document.getElementById('rcp-student');
    if(sel){ sel.value=id; onReceiptStudentChange(); }
  },400);
}

// ═══════════════════════════════
//  ATTENDANCE
// ═══════════════════════════════
function loadAttendance(){
  S.attDate=document.getElementById('att-date').value;
  S.attClass=document.getElementById('att-class').value;
  document.getElementById('att-tbody').innerHTML='<tr><td colspan="3" class="loader">Loading…</td></tr>';
  call('getAttendanceForDate',{date:S.attDate,cls:S.attClass},function(err,data){
    if(err) return toast('Error: '+err);
    S.attRecords=data.sort(cmpName);
    var p=data.filter(function(r){return r.Status==='Present';}).length;
    document.getElementById('att-count').textContent=data.length+' students · '+p+' present';
    if(!data.length){document.getElementById('att-tbody').innerHTML='<tr><td colspan="3" style="padding:14px;color:#8A9E9B">No students.</td></tr>';return;}
    document.getElementById('att-tbody').innerHTML=data.map(function(r,i){
      var st=r.Status||'Present';
      return '<tr><td class="name-cell"><strong>'+r.Name+'</strong></td><td><span class="tag" style="background:#F0EDE8;color:#6B8A87">'+r.Class+'</span></td>'
        +'<td><div class="tog-group">'
        +'<button class="tog'+(st==='Present'?' sel-present':'')+'" onclick="setAtt('+i+',\'Present\',this)">Present</button>'
        +'<button class="tog'+(st==='Absent'?' sel-absent':'')+'" onclick="setAtt('+i+',\'Absent\',this)">Absent</button>'
        +'</div></td></tr>';
    }).join('');
  });
}
function setAtt(i,status,btn){
  S.attRecords[i].Status=status;
  var g=btn.parentElement; g.querySelectorAll('.tog').forEach(function(b){b.className='tog';});
  btn.classList.add('sel-'+status.toLowerCase());
  var p=S.attRecords.filter(function(r){return r.Status==='Present';}).length;
  document.getElementById('att-count').textContent=S.attRecords.length+' students · '+p+' present';
}
function saveAttendance(){
  call('saveAttendance',{date:S.attDate,records:S.attRecords},function(err){
    if(err) return toast('Error: '+err);
    toast('Attendance saved ✓');S.cache.attendance=null;loadDashboard();
  });
}

// ═══════════════════════════════
//  FEES
// ═══════════════════════════════
function loadFees(){
  S.feeMonth=document.getElementById('fees-month').value;
  if(S.cache.fees){
    var stuMap={};
    (S.cache.students||[]).forEach(function(s){stuMap[s.StudentID]=s;});
    S.fees=(S.cache.fees||[]).filter(function(f){return f.Month===S.feeMonth;}).map(function(f){
      var s=stuMap[f.StudentID]||{};
      return Object.assign({},f,{
        StudentName:f.StudentName||s.Name||'Unknown',
        Class:f.Class||s.Class||'',
        StudentStatus:f.StudentStatus||s.Status||'',
        Phone:f.Phone||s.Phone||''
      });
    });
    renderFees();
  } else {
    call('getFees',{month:S.feeMonth},function(err,data){
      if(err) return toast('Error: '+err);
      S.fees=data; renderFees();
    });
  }
}

function setFeeFilter(f,el){
  S.feeFilter=f;
  document.querySelectorAll('#screen-fees .filter-tabs .ftab').forEach(function(t){t.classList.remove('active');});
  el.classList.add('active');
  renderFees();
}

function renderFees(){
  var data = S.fees.filter(function(f){ return f.StudentStatus !== 'Inactive'; });

  var grouped = {};
  data.forEach(function(f){
    var sid = f.StudentID;
    if(!grouped[sid]) grouped[sid]={ StudentName:f.StudentName, Class:f.Class, Phone:f.Phone, Month:f.Month, monthly:null, camera:null, others:[] };
    var ft = (f.FeeType||'Monthly');
    if(ft==='Monthly') grouped[sid].monthly = f;
    else if(ft==='Camera') grouped[sid].camera = f;
    else grouped[sid].others.push(f);
  });

  var rows = Object.values(grouped);

  if(S.feeFilter !== 'all'){
    rows = rows.filter(function(r){
      if(S.feeFilter === 'Unpaid'){
        return (r.monthly&&r.monthly.Status==='Unpaid') || (r.camera&&r.camera.Status==='Unpaid') || r.others.some(function(o){return o.Status==='Unpaid';});
      }
      if(S.feeFilter === 'Paid'){
        var allPaid = (!r.monthly||r.monthly.Status==='Paid') && (!r.camera||r.camera.Status==='Paid') && r.others.every(function(o){return o.Status==='Paid';});
        return allPaid;
      }
      return true;
    });
  }

  rows.sort(function(a,b){
    var aUnpaid = (a.monthly&&a.monthly.Status==='Unpaid')||(a.camera&&a.camera.Status==='Unpaid');
    var bUnpaid = (b.monthly&&b.monthly.Status==='Unpaid')||(b.camera&&b.camera.Status==='Unpaid');
    if(aUnpaid && !bUnpaid) return -1;
    if(!aUnpaid && bUnpaid) return 1;
    return a.StudentName.localeCompare(b.StudentName);
  });

  if(!rows.length){
    document.getElementById('fees-tbody').innerHTML='<tr><td colspan="9" style="padding:14px;color:#8A9E9B">No records. Click "Generate Fees" to create.</td></tr>';
    return;
  }

  var html = '';
  rows.forEach(function(r){
    var m = r.monthly;
    var c = r.camera;
    var monthlyAmt = m ? Number(m.Amount) : 0;
    var cameraAmt = c ? Number(c.Amount) : 0;
    var total = monthlyAmt + cameraAmt + r.others.reduce(function(s,o){return s+Number(o.Amount);},0);

    var anyUnpaid = (m&&m.Status==='Unpaid')||(c&&c.Status==='Unpaid')||r.others.some(function(o){return o.Status==='Unpaid';});
    var paidDate = m&&m.PaymentDate ? fmtDate(m.PaymentDate) : (c&&c.PaymentDate ? fmtDate(c.PaymentDate) : '—');

    var unpaidIDs = [];
    if(m&&m.Status==='Unpaid') unpaidIDs.push(m.FeeID);
    if(c&&c.Status==='Unpaid') unpaidIDs.push(c.FeeID);
    r.others.forEach(function(o){if(o.Status==='Unpaid') unpaidIDs.push(o.FeeID);});

    var actions = '';
    if(unpaidIDs.length > 0){
      actions += '<button class="btn btn-sm btn-primary" onclick="onBulkMarkPaidClick(this)" data-ids="'+unpaidIDs.join(',')+'" data-name="'+(r.StudentName||'').replace(/"/g, '&quot;')+'" data-total="'+total+'">Mark Paid</button> ';
    }
    if(r.Phone){
      actions += '<button class="btn btn-sm btn-wa" onclick="onWaReminderClick(this)" data-phone="'+r.Phone+'" data-name="'+(r.StudentName||'').replace(/"/g, '&quot;')+'" data-amount="'+total+'">📲</button>';
    }

    var monthlyDisp = m ? '₹'+fmt(m.Amount) : '—';
    var monthlyStatusBadge = m ? '<span class="tag tag-'+(m.Status==='Paid'?'paid':'unpaid')+'" style="margin-left:4px;font-size:9px">'+m.Status+'</span>' : '';

    var cameraDisp = c ? '₹'+fmt(c.Amount) : '—';
    var cameraStatusBadge = c ? '<span class="tag tag-'+(c.Status==='Paid'?'paid':'unpaid')+'" style="margin-left:4px;font-size:9px">'+c.Status+'</span>' : '';

    html += '<tr class="'+(anyUnpaid?'tbl-unpaid':'')+'">'
      + '<td class="name-cell"><strong>'+r.StudentName+'</strong></td>'
      + '<td>'+r.Class+'</td>'
      + '<td>'+fmtMonth(r.Month)+'</td>'
      + '<td><span style="font-family:\'DM Mono\',monospace;font-size:12px">'+monthlyDisp+'</span>'+monthlyStatusBadge+'</td>'
      + '<td><span style="font-family:\'DM Mono\',monospace;font-size:12px;color:'+(c?'#6A1B9A':'#C5C0BA')+'">'+cameraDisp+'</span>'+(c?cameraStatusBadge:'')+'</td>'
      + '<td style="font-family:\'DM Mono\',monospace;font-weight:700">₹'+fmt(total)+'</td>'
      + '<td><span class="tag tag-'+(anyUnpaid?'unpaid':'paid')+'">'+(anyUnpaid?'Pending':'Paid')+'</span></td>'
      + '<td>'+(anyUnpaid?'—':paidDate)+'</td>'
      + '<td>'+actions+'</td>'
      + '</tr>';

    r.others.forEach(function(o){
      html += '<tr class="fee-combined-row '+(o.Status==='Unpaid'?'tbl-unpaid':'')+'">'
        +'<td colspan="2"></td>'
        +'<td><span class="tag tag-'+(o.FeeType||'late').toLowerCase()+'">'+o.FeeType+'</span></td>'
        +'<td colspan="2" style="font-family:\'DM Mono\',monospace;font-size:11px">₹'+fmt(o.Amount)+'</td>'
        +'<td></td>'
        +'<td><span class="tag tag-'+(o.Status==='Paid'?'paid':'unpaid')+'">'+o.Status+'</span></td>'
        +'<td>'+(o.PaymentDate?fmtDate(o.PaymentDate):'—')+'</td>'
        +'<td>'+(o.Status==='Unpaid'?'<button class="btn btn-sm btn-primary" onclick="openMarkFeePaid(\''+o.FeeID+'\')">Pay</button>':'')+'</td>'
        +'</tr>';
    });
  });

  document.getElementById('fees-tbody').innerHTML = html;
}

function openBulkMarkPaid(feeIDs, studentName, total){
  S._pendingBulkFeeIDs = feeIDs;
  S._pendingBulkStudentName = studentName;
  document.getElementById('fee-bulk-info').innerHTML =
    '<strong>'+studentName+'</strong><br>Marking '+feeIDs.length+' fee item(s) as paid<br>Total: <strong style="font-family:\'DM Mono\',monospace">₹'+fmt(total)+'</strong>';
  document.getElementById('fee-bulk-date').value = todayVal();
  document.getElementById('modal-fee-bulk').style.display='flex';
}
function confirmMarkFeesBulkPaid(){
  var date = document.getElementById('fee-bulk-date').value;
  var mode = document.getElementById('fee-bulk-mode').value;
  var ids = S._pendingBulkFeeIDs;
  call('markFeesPaid',{feeIDs:ids,paymentDate:date,mode:mode},function(err){
    if(err) return toast('Error: '+err);
    closeModal('modal-fee-bulk');
    toast('Fees marked paid ✓');
    warmCache(function(){
      loadFees();
      loadDashboard();
    }, true);
  });
}

function generateFees(){
  toast('Generating…');
  call('generateMonthlyFees',{month:S.feeMonth},function(err,d){
    if(err) return toast('Error: '+err);
    var msg = d.added > 0 ? 'Generated '+d.added+' fee records ✓' : 'All fees already exist for this month';
    toast(msg);
    S.cache.fees = null;
    call('getFees',{month:S.feeMonth},function(err2,data){
      if(err2) return toast('Error loading fees: '+err2);
      S.fees = data;
      renderFees();
    });
  });
}
function openMarkFeePaid(feeID){
  document.getElementById('fee-id').value=feeID;
  document.getElementById('fee-date').value=todayVal();
  document.getElementById('modal-fee').style.display='flex';
}
function confirmMarkFeePaid(){
  call('markFeePaid',{feeID:document.getElementById('fee-id').value,paymentDate:document.getElementById('fee-date').value,mode:document.getElementById('fee-mode').value},function(err){
    if(err) return toast('Error: '+err);
    closeModal('modal-fee');
    toast('Fee marked paid ✓');
    warmCache(function(){
      loadFees();
      loadDashboard();
    }, true);
  });
}

// ═══════════════════════════════
//  RECEIPT BUILDER
// ═══════════════════════════════
function initReceiptBuilder() {
  S.rcpItems=[];
  var students = (S.cache.students||S.students||[])
    .filter(function(s){return s.Status==='Active';})
    .sort(cmpName);

  var sel=document.getElementById('rcp-student');
  sel.innerHTML='<option value="">Select student…</option>';

  var classOrder = ['Pre-Nursery','Nursery','LKG'];
  classOrder.forEach(function(cls){
    var inClass = students.filter(function(s){return s.Class===cls;});
    if(inClass.length){
      var og = document.createElement('optgroup');
      og.label = cls + ' (' + inClass.length + ')';
      inClass.forEach(function(s){
        var o = document.createElement('option');
        o.value = s.StudentID;
        o.textContent = s.Name;
        og.appendChild(o);
      });
      sel.appendChild(og);
    }
  });

  var nextNo = S.cache.nextReceiptNo || '0518';
  document.getElementById('rcp-no').value = nextNo;
  updateReceiptPreview();
}

function onReceiptStudentChange() {
  var id=document.getElementById('rcp-student').value;
  S.rcpItems=[];
  document.getElementById('rcp-due-fees').innerHTML='';
  if(!id){renderRcpItems();updateReceiptPreview();return;}
  var students = S.cache.students||S.students||[];
  var s=students.find(function(x){return x.StudentID===id;});
  if(s){
    document.getElementById('rp-student').textContent=s.Name;
    document.getElementById('rp-parent').textContent=s.FatherGuardianName||'—';
    document.getElementById('rp-class').textContent=s.Class;
    
    // Auto-populate default fees synchronously for instant response
    if(s.FeeAmount) {
      S.rcpItems.push({desc:'Tuition Fee',amount:Number(s.FeeAmount),feeID:null,editable:true});
    }
    if(isCamOn(s.CameraSubscribed)) {
      var camAmt = Number((S.settings && S.settings.camera_charge) || 500);
      S.rcpItems.push({desc:'Camera Fee',amount:camAmt,feeID:null,editable:true});
    }
    renderRcpItems();
    updateReceiptPreview();
  }

  var rcpMonth = (document.getElementById('rcp-date').value||todayVal()).substring(0,7);
  call('getStudentFees',{studentID:id, month:rcpMonth},function(err,data){
    var el=document.getElementById('rcp-due-fees');
    if(err||!data||!data.length){
      if(el) el.innerHTML='<p style="font-size:10px;color:#8A9E9B">No unpaid fee records found — using standard tuition.</p>';
      return;
    }
    var unpaid=data.filter(function(f){return f.Status==='Unpaid';});
    if(unpaid.length > 0) {
      S.rcpItems=[];
      var monthly=unpaid.filter(function(f){return (f.FeeType||'Monthly')==='Monthly';});
      var camera=unpaid.filter(function(f){return f.FeeType==='Camera';});
      var others=unpaid.filter(function(f){return f.FeeType!=='Monthly'&&f.FeeType!=='Camera';});
      monthly.forEach(function(f){ S.rcpItems.push({desc:'Tuition Fee',amount:Number(f.Amount),feeID:f.FeeID,editable:true}); });
      camera.forEach(function(f){ S.rcpItems.push({desc:'Camera Fee',amount:Number(f.Amount),feeID:f.FeeID,editable:true}); });
      others.forEach(function(f){ S.rcpItems.push({desc:(f.FeeType||'Other')+' Fee',amount:Number(f.Amount),feeID:f.FeeID,editable:true}); });

      if(s && isCamOn(s.CameraSubscribed) && camera.length === 0) {
        var camAmt = Number((S.settings && S.settings.camera_charge) || 500);
        if(!S.rcpItems.some(function(i){ return i.desc === 'Camera Fee'; })) {
          S.rcpItems.push({desc:'Camera Fee',amount:camAmt,feeID:null,editable:true});
        }
      }
      renderRcpItems();updateReceiptPreview();
      if(el) el.innerHTML='<p style="font-size:10px;color:#6EC6C4;font-weight:600">✓ '+unpaid.length+' unpaid fee item(s) loaded</p>';
    } else {
      if(el) el.innerHTML='<p style="font-size:10px;color:#2E7D32">All fees paid for this month ✓</p>';
    }
  });
}

function addReceiptItem(){
  var desc=document.getElementById('rcp-custom-desc').value.trim();
  var amt=parseFloat(document.getElementById('rcp-custom-amt').value);
  if(!desc||!amt) return toast('Enter description and amount');
  S.rcpItems.push({desc:desc,amount:amt,feeID:null});
  document.getElementById('rcp-custom-desc').value='';document.getElementById('rcp-custom-amt').value='';
  renderRcpItems();updateReceiptPreview();
}
function removeRcpItem(i){S.rcpItems.splice(i,1);renderRcpItems();updateReceiptPreview();}
function editRcpItemAmt(i,val){S.rcpItems[i].amount=parseFloat(val)||0;updateReceiptPreview();}
function renderRcpItems(){
  var total=S.rcpItems.reduce(function(s,i){return s+i.amount;},0);
  document.getElementById('rcp-items-list').innerHTML=S.rcpItems.map(function(it,i){
    return '<div class="ri-row">'
      +'<span class="ri-desc">'+it.desc+'</span>'
      +'<input type="number" class="inp" value="'+it.amount+'" style="width:72px;padding:3px 6px;font-size:11px;font-family:\'DM Mono\',monospace;text-align:right" onchange="editRcpItemAmt('+i+',this.value)" oninput="editRcpItemAmt('+i+',this.value)">'
      +'<button class="ri-remove" onclick="removeRcpItem('+i+')">×</button>'
      +'</div>';
  }).join('');
  document.getElementById('rcp-total').textContent='₹'+fmt(total);
}
function updateReceiptPreview(){
  var total=S.rcpItems.reduce(function(s,i){return s+i.amount;},0);
  document.getElementById('rp-date').textContent=fmtDate(document.getElementById('rcp-date').value);
  document.getElementById('rp-no').textContent=document.getElementById('rcp-no').value||'—';
  document.getElementById('rp-mode').textContent=document.getElementById('rcp-mode').value||'—';
  var itemsHTML=S.rcpItems.map(function(it){
    return '<div class="rp-item-row"><span class="desc">'+it.desc+'</span><span class="amt">₹'+fmt(it.amount)+'</span></div>';
  }).join('');
  document.getElementById('rp-items-display').innerHTML=itemsHTML;
  document.getElementById('rp-total-val').textContent='₹'+fmt(total);
  document.getElementById('rp-in-words').textContent=total>0?'('+numToWords(total)+' Rupees Only/-)':'';
  var rcpDateVal=document.getElementById('rcp-date').value;
  var months=rcpDateVal?rcpDateVal.substring(0,7):'';
  document.getElementById('rp-months').textContent=months?fmtMonth(months):'—';
  var ld=document.getElementById('rp-logo-display');
  if(S.rcpImages.rcp_logo){
    ld.className='rp-logo-placeholder';
    ld.innerHTML='<img src="'+S.rcpImages.rcp_logo+'" style="width:100%;height:100%;object-fit:contain;display:block;">';
    var hint=document.getElementById('rp-logo-hint');
    if(hint) hint.style.display='none';
  }
  var wm=document.getElementById('rp-wm-area');
  if(S.rcpImages.rcp_wm){
    wm.innerHTML='<img src="'+S.rcpImages.rcp_wm+'" style="width:200px;height:200px;object-fit:contain;opacity:.07;pointer-events:none;">';
  }
  var sd=document.getElementById('rp-stamp-display');
  if(S.rcpImages.rcp_stamp){
    sd.className='rp-stamp-placeholder';
    sd.style.border='none';
    sd.innerHTML='<img src="'+S.rcpImages.rcp_stamp+'" style="width:70px;height:70px;object-fit:contain;border-radius:50%;display:block;">';
  }
  if(S.settings&&S.settings.school_name){
    var sn=document.getElementById('rp-school-name');
    if(sn) sn.textContent=S.settings.school_name;
  }
}
document.addEventListener('input',function(e){
  if(['rcp-date','rcp-no','rcp-mode'].indexOf(e.target.id)>=0) updateReceiptPreview();
});

function triggerUpload(id){document.getElementById(id).click();}
function previewReceiptImg(inputId,prevId,key){
  var file=document.getElementById(inputId).files[0];
  if(!file) return;
  var r=new FileReader();
  r.onload=function(e){
    S.rcpImages[key]=e.target.result;
    var prev=document.getElementById(prevId);
    prev.innerHTML='<img src="'+e.target.result+'" style="width:48px;height:48px;object-fit:contain;border-radius:6px;display:block;">';
    updateReceiptPreview();
  };
  r.readAsDataURL(file);
}

function addTextBox(){
  var wrap=document.getElementById('rp-text-boxes');
  var box=document.createElement('div');
  box.className='rp-text-box';
  box.contentEditable=true;
  box.textContent='Edit text here';
  box.style.left='20px';
  box.style.top='20px';
  box.style.position='absolute';
  var del=document.createElement('span');
  del.textContent='×';
  del.style.cssText='position:absolute;top:-8px;right:-8px;width:16px;height:16px;background:#EF5350;color:#fff;border-radius:50%;font-size:10px;font-style:normal;display:flex;align-items:center;justify-content:center;cursor:pointer;line-height:1;z-index:99;';
  del.className='no-print';
  del.onclick=function(e){ e.stopPropagation(); wrap.removeChild(box); };
  box.appendChild(del);
  makeDraggable(box);
  wrap.appendChild(box);
}
function makeDraggable(el){
  el.addEventListener('mousedown',function(e){
    var ox=e.clientX-el.offsetLeft,oy=e.clientY-el.offsetTop;
    function mv(e2){el.style.left=(e2.clientX-ox)+'px';el.style.top=(e2.clientY-oy)+'px';}
    function up(){document.removeEventListener('mousemove',mv);document.removeEventListener('mouseup',up);}
    document.addEventListener('mousemove',mv);document.addEventListener('mouseup',up);
  });
}

function captureReceiptCanvas(){
  var el=document.getElementById('rp-wrap');
  if(!el) return Promise.reject(new Error('Receipt not ready'));
  var students = S.cache.students||S.students||[];
  var sid=document.getElementById('rcp-student').value;
  var s=students.find(function(x){return x.StudentID===sid;});
  var nameStr = 'Receipt';
  if (s && s.Name) {
    var parts = s.Name.trim().split(/\s+/);
    var firstName = parts[0] || '';
    var surname = parts.length > 1 ? parts[parts.length - 1] : '';
    var surname3 = surname ? surname.substring(0, 3) : '';
    nameStr = firstName + (surname3 ? ' ' + surname3 : '');
  }
  var dateVal=document.getElementById('rcp-date').value;
  var dp=dateVal?dateVal.split('-'):[];
  var mns=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var mLabel=dp.length>=2?(mns[parseInt(dp[1])-1]+dp[0].slice(-2)):'';
  var filename=nameStr+(mLabel?'_'+mLabel:'')+'_Fee Receipt.png';
  var noPrint=document.querySelectorAll('.no-print');
  noPrint.forEach(function(e){e.style.visibility='hidden';});
  var textBoxes=document.querySelectorAll('.rp-text-box');
  textBoxes.forEach(function(b){b.style.borderStyle='none';b.style.background='transparent';});
  return html2canvas(el,{scale:3,useCORS:true,backgroundColor:'#ffffff',logging:false})
    .then(function(canvas){
      noPrint.forEach(function(e){e.style.visibility='';});
      textBoxes.forEach(function(b){b.style.borderStyle='dashed';b.style.background='rgba(255,255,255,.9)';});
      return {canvas:canvas, filename:filename};
    })
    .catch(function(err){
      noPrint.forEach(function(e){e.style.visibility='';});
      textBoxes.forEach(function(b){b.style.borderStyle='dashed';b.style.background='rgba(255,255,255,.9)';});
      throw err;
    });
}

function downloadCanvasPNG(canvas, filename) {
  return new Promise(function(resolve) {
    canvas.toBlob(function(blob) {
      var blobUrl = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.style.display = 'none';
      link.download = filename;
      link.href = blobUrl;
      document.body.appendChild(link);
      link.click();
      setTimeout(function() {
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
        resolve();
      }, 1000);
    }, 'image/png');
  });
}

function generateReceiptPDF(){
  toast('Generating image…');
  captureReceiptCanvas().then(function(r){
    downloadCanvasPNG(r.canvas, r.filename).then(function() {
      toast('Downloaded: '+r.filename+' ✓');
    });
  }).catch(function(err){ toast('Error: '+(err.message||err)); });
}

function saveReceiptToDB(opts){
  var students = S.cache.students||S.students||[];
  var sid=document.getElementById('rcp-student').value;
  if(!sid||!S.rcpItems.length) return toast('Select a student and add items');
  var s=students.find(function(x){return x.StudentID===sid;});
  var total=S.rcpItems.reduce(function(sum,i){return sum+i.amount;},0);
  var feeIDs=S.rcpItems.filter(function(i){return i.feeID;}).map(function(i){return i.feeID;});
  var payDate=document.getElementById('rcp-date').value||todayVal();
  var mode=document.getElementById('rcp-mode').value;
  return new Promise(function(resolve, reject){
    call('saveReceipt',{
      receiptNo:document.getElementById('rcp-no').value,
      studentID:sid,
      studentName:s?s.Name:'',
      parentName:s?s.FatherGuardianName:'',
      class_:s?s.Class:'',
      date:payDate,
      items:S.rcpItems,
      totalAmount:total,
      mode:mode,
      feeIDs:feeIDs
    },function(err){
      if(err){ toast('Error: '+err); return reject(err); }
      S.cache.fees=null;
      if(!(opts&&opts.silent)) toast('Receipt saved — fees marked paid ✓');
      var cur=parseInt(String(document.getElementById('rcp-no').value).replace(/\D/g,''))||517;
      document.getElementById('rcp-no').value=String(cur+1).padStart(4,'0');
      S.cache.nextReceiptNo=document.getElementById('rcp-no').value;
      resolve({feeIDs:feeIDs, studentName:s?s.Name:''});
    });
  });
}

function sendReceiptWhatsApp(){
  var students = S.cache.students||S.students||[];
  var sid = document.getElementById('rcp-student').value;
  if(!sid) return toast('Select a student first');
  var s = students.find(function(x){ return x.StudentID === sid; });
  if(!s || !s.Phone) return toast('No WhatsApp number on record for this student');
  var total = S.rcpItems.reduce(function(sum, i){ return sum + i.amount; }, 0);
  if(!total) return toast('Add fee items before sending');

  var rcpNo      = document.getElementById('rcp-no').value || '—';
  var rcpDate    = fmtDate(document.getElementById('rcp-date').value) || '—';
  var monthLabel = fmtMonth((document.getElementById('rcp-date').value||'').substring(0,7)) || '—';
  var parentName = s.FatherGuardianName || 'Parent';
  var msg = 'Dear ' + parentName + ',\n\nThank you for your payment.\n\nWe have received the fees for ' + s.Name + ' (' + s.Class + ') for the month of ' + monthLabel + '. Please find the fee receipt attached.\n\nWarm regards,\nTiny Detectives School';

  // 1. Open WhatsApp synchronously (must be in direct click handler to avoid popup blocker)
  var waUrl = 'https://wa.me/91' + s.Phone + '?text=' + encodeURIComponent(msg);
  var a = document.createElement('a');
  a.href = waUrl; a.target = '_blank'; a.rel = 'noopener noreferrer';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  // 2. Save to DB and download image in the background
  toast('Saving receipt & downloading image…');
  var saveP  = saveReceiptToDB({silent:true});
  var imageP = captureReceiptCanvas();

  Promise.all([saveP, imageP]).then(function(results){
    var imgResult = results[1];
    downloadCanvasPNG(imgResult.canvas, imgResult.filename).then(function() {
      toast('Receipt saved, image downloaded, WhatsApp opened ✓');
    });
  }).catch(function(err){
    toast('Error saving/downloading receipt: ' + (err.message || err));
  });
}

function numToWords(n){
  var ones=['','One','Two','Three','Four','Five','Six','Seven','Eight','Nine','Ten','Eleven','Twelve','Thirteen','Fourteen','Fifteen','Sixteen','Seventeen','Eighteen','Nineteen'];
  var tens=['','','Twenty','Thirty','Forty','Fifty','Sixty','Seventy','Eighty','Ninety'];
  function h(n){
    if(n<20) return ones[n];
    if(n<100) return tens[Math.floor(n/10)]+(n%10?' '+ones[n%10]:'');
    return ones[Math.floor(n/100)]+' Hundred'+(n%100?' '+h(n%100):'');
  }
  if(n===0) return 'Zero';
  var result='',num=Math.round(n);
  if(num>=10000000){result+=h(Math.floor(num/10000000))+' Crore ';num%=10000000;}
  if(num>=100000){result+=h(Math.floor(num/100000))+' Lakh ';num%=100000;}
  if(num>=1000){result+=h(Math.floor(num/1000))+' Thousand ';num%=1000;}
  if(num>0) result+=h(num);
  return result.trim();
}

// ═══════════════════════════════
//  TEACHERS
// ═══════════════════════════════
function loadTeachers(){
  var data=(S.cache.teachers||S.teachers||[]).sort(cmpName);
  S.teachers=data;
  if(!data.length){document.getElementById('teachers-tbody').innerHTML='<tr><td colspan="6" style="padding:14px;color:#8A9E9B">No teachers yet. Click "+ Add Teacher".</td></tr>';return;}
  document.getElementById('teachers-tbody').innerHTML=data.map(function(t){
    var role=t.Class?t.Class:'Helper';
    return '<tr><td class="name-cell"><strong>'+t.Name+'</strong></td>'
      +'<td>'+role+'</td>'
      +'<td class="salary-cell"><span class="salary-mask">₹ •••••</span><span class="salary-reveal" style="font-family:\'DM Mono\',monospace">₹'+fmt(t.Salary)+'</span></td>'
      +'<td>'+fmtDate(t.JoiningDate||'')+'</td>'
      +'<td><span class="tag tag-active">Active</span></td>'
      +'<td><button class="btn btn-outline btn-sm" onclick="openEditTeacher(\''+t.TeacherID+'\')">Edit</button></td></tr>';
  }).join('');
}
function openAddTeacher(){
  document.getElementById('modal-tch-title').textContent='Add Teacher';
  document.getElementById('tch-id').value='';
  ['tch-name','tch-salary','tch-notes','tch-exit-date'].forEach(function(id){document.getElementById(id).value='';});
  document.getElementById('tch-class').value='';document.getElementById('tch-exit-reason').value='';document.getElementById('tch-joining').value=todayVal();
  document.getElementById('modal-teacher').style.display='flex';
}
function openEditTeacher(id){
  var t=S.teachers.find(function(x){return x.TeacherID===id;});
  if(!t) return;
  document.getElementById('modal-tch-title').textContent='Edit Teacher';
  document.getElementById('tch-id').value=t.TeacherID;
  document.getElementById('tch-name').value=t.Name;
  document.getElementById('tch-class').value=t.Class||'';
  document.getElementById('tch-salary').value=t.Salary;
  document.getElementById('tch-joining').value=t.JoiningDate||'';
  document.getElementById('tch-exit-date').value=t.ExitDate||'';
  document.getElementById('tch-exit-reason').value=t.ExitReason||'';
  document.getElementById('tch-notes').value=t.Notes||'';
  document.getElementById('modal-teacher').style.display='flex';
}
function saveTeacher(){
  var id=document.getElementById('tch-id').value;
  var exitDate=document.getElementById('tch-exit-date').value;
  var exitReason=document.getElementById('tch-exit-reason').value;
  var payload={TeacherID:id,Name:document.getElementById('tch-name').value.trim(),Class:document.getElementById('tch-class').value,Salary:parseFloat(document.getElementById('tch-salary').value)||0,JoiningDate:document.getElementById('tch-joining').value,ExitDate:exitDate,ExitReason:exitReason,Notes:document.getElementById('tch-notes').value.trim(),Status:(exitDate&&exitReason&&exitReason!=='')?'Inactive':'Active'};
  if(!payload.Name) return toast('Enter teacher name');
  call(id?'updateTeacher':'addTeacher',payload,function(err){
    if(err) return toast('Error: '+err);
    closeModal('modal-teacher');toast('Teacher saved ✓');
    S.cache.teachers=null; loadTeachers();
  });
}

// ═══════════════════════════════
//  TEACHER ATTENDANCE
// ═══════════════════════════════
function loadTeacherAttendance(){
  S.tattDate=document.getElementById('tatt-date').value;
  var teachers=(S.cache.teachers||S.teachers||[]).sort(cmpName);
  var tattData=S.cache.teacherAtt||[];
  var attMap={};
  tattData.filter(function(a){return String(a.Date).substring(0,10)===S.tattDate;}).forEach(function(a){attMap[a.TeacherID]=a.Status;});
  S.tattRecords=teachers.map(function(t){
    return {TeacherID:t.TeacherID,Name:t.Name,Class:t.Class||'',Status:attMap[t.TeacherID]||'Present'};
  });
  if(!S.tattRecords.length){document.getElementById('tatt-tbody').innerHTML='<tr><td colspan="3" style="padding:14px;color:#8A9E9B">No teachers. Add teachers first.</td></tr>';return;}
  document.getElementById('tatt-tbody').innerHTML=S.tattRecords.map(function(r,i){
    var role=r.Class?r.Class:'Helper';
    var st=r.Status||'Present';
    return '<tr><td class="name-cell"><strong>'+r.Name+'</strong><span>'+role+'</span></td><td>'+role+'</td>'
      +'<td><div class="tog-group">'
      +'<button class="tog'+(st==='Present'?' sel-present':'')+'" onclick="setTAtt('+i+',\'Present\',this)">Present</button>'
      +'<button class="tog'+(st==='Half Day'?' sel-halfday':'')+'" onclick="setTAtt('+i+',\'Half Day\',this)">Half Day</button>'
      +'<button class="tog'+(st==='Leave'?' sel-leave':'')+'" onclick="setTAtt('+i+',\'Leave\',this)">Leave</button>'
      +'</div></td></tr>';
  }).join('')
  +'<tr><td colspan="3" style="padding:10px 12px"><button class="btn btn-primary" onclick="saveTeacherAttendance()">💾 Save Teacher Attendance</button></td></tr>';
}
function setTAtt(i,status,btn){
  S.tattRecords[i].Status=status;
  var g=btn.parentElement;g.querySelectorAll('.tog').forEach(function(b){b.className='tog';});
  btn.classList.add('sel-'+status.toLowerCase().replace(' ',''));
}
function saveTeacherAttendance(){
  call('saveTeacherAttendance',{date:S.tattDate,records:S.tattRecords},function(err){
    if(err) return toast('Error: '+err);
    toast('Teacher attendance saved ✓');S.cache.teacherAtt=null;
  });
}

// ═══════════════════════════════
//  SALARY
// ═══════════════════════════════
function loadSalary(){
  S.salMonth=document.getElementById('salary-month').value;
  call('getSalary',{month:S.salMonth},function(err,data){
    if(err) return toast('Error: '+err);
    renderSalary(data);
  });
}
function renderSalary(data){
  if(!data.length){document.getElementById('salary-tbody').innerHTML='<tr><td colspan="8" style="padding:14px;color:#8A9E9B">No records. Click "Compute Salary".</td></tr>';return;}
  document.getElementById('salary-tbody').innerHTML=data.map(function(s){
    var ip=s.Status==='Paid';
    return '<tr><td><strong>'+s.Name+'</strong></td><td>'+s.WorkingDays+'</td><td>'+s.DaysPresent+'</td><td>'+s.Leaves+'</td><td>'+s.HalfDays+'</td>'
      +'<td style="font-family:\'DM Mono\',monospace;font-weight:700">₹'+fmt(s.FinalSalary)+'</td>'
      +'<td><span class="tag '+(ip?'tag-paid':'tag-unpaid')+'">'+s.Status+'</span></td>'
      +'<td>'+(ip?'—':'<button class="btn btn-sm btn-primary" onclick="markSalaryPaid(\''+s.SalaryID+'\')">Mark Paid</button>')+'</td></tr>';
  }).join('');
}
function computeSalary(){
  toast('Computing…');
  call('computeSalary',{month:document.getElementById('salary-month').value},function(err,data){
    if(err) return toast('Error: '+err);
    if(!data||!data.length){toast('No active teachers.');return;}
    renderSalary(data);toast('Salary computed ✓');
  });
}
function markSalaryPaid(id){
  call('markSalaryPaid',{salaryID:id,paidDate:todayVal()},function(err){
    if(err) return toast('Error: '+err);
    toast('Salary marked paid ✓');loadSalary();
  });
}

// ═══════════════════════════════
//  ACTIVITY CALENDAR
// ═══════════════════════════════
function loadActivityCalendar(){
  var actMonth=S.actCalYear+'-'+pad(S.actCalMonth+1);
  if(S.cache.activity){
    var cached=(S.cache.activity||[]).filter(function(a){return String(a.Date).substring(0,7)===actMonth;});
    S.activityData=cached;
    renderActivityCalendar();
    var todayMonth=new Date().getFullYear()+'-'+pad(new Date().getMonth()+1);
    if(actMonth!==todayMonth){
      call('getActivity',{month:actMonth},function(err,data){
        if(!err){S.activityData=data||[];renderActivityCalendar();}
      });
    }
  } else {
    call('getActivity',{month:actMonth},function(err,data){
      if(err) return toast('Error: '+err);
      S.activityData=data||[];
      renderActivityCalendar();
    });
  }
}
function actCalPrev(){S.actCalMonth--;if(S.actCalMonth<0){S.actCalMonth=11;S.actCalYear--;}loadActivityCalendar();}
function actCalNext(){S.actCalMonth++;if(S.actCalMonth>11){S.actCalMonth=0;S.actCalYear++;}loadActivityCalendar();}

function renderActivityCalendar(){
  var yr=S.actCalYear,mo=S.actCalMonth;
  var monthNames=['January','February','March','April','May','June','July','August','September','October','November','December'];
  document.getElementById('act-cal-title').textContent=monthNames[mo]+' '+yr;
  var clsFilter=document.getElementById('act-class-filter').value;
  var data=S.activityData.filter(function(a){return !clsFilter||a.Class===clsFilter||!a.Class;});
  var byDate={};
  data.forEach(function(a){
    var d=String(a.Date);
    if(!byDate[d]) byDate[d]=[];
    byDate[d].push(a);
  });
  window._actByDate = byDate;
  var firstDay=new Date(yr,mo,1).getDay();
  var daysInMonth=new Date(yr,mo+1,0).getDate();
  var prevDays=new Date(yr,mo,0).getDate();
  var todayStr2=todayVal();
  var cells='';
  for(var i=firstDay-1;i>=0;i--){
    cells+='<div class="act-cal-cell other-month"><div class="acc-date">'+(prevDays-i)+'</div></div>';
  }
  for(var d2=1;d2<=daysInMonth;d2++){
    var dateStr=yr+'-'+pad(mo+1)+'-'+pad(d2);
    var isToday=dateStr===todayStr2;
    var dayActivities=byDate[dateStr]||[];
    var chips=dayActivities.map(function(a){
      var kw=(a.Keyword&&String(a.Keyword).trim())||(a.Tags&&String(a.Tags).trim())||'Activity';
      var note=a.Notes?(kw+': '+a.Notes):kw;
      var logID=a.LogID||'';
      return '<span class="act-kw-chip" onclick="event.stopPropagation();openEditActivity(\''+logID+'\',\''+dateStr+'\',\''+encodeURIComponent(kw)+'\',\''+encodeURIComponent(a.Notes||'')+'\',\''+encodeURIComponent(a.Class||'')+'\')" title="'+note+'">'+kw+'<span class="act-tooltip">'+note+'</span></span>';
    }).join('');
    cells+='<div class="act-cal-cell'+(isToday?' today-cell':'')+'" onclick="showDayActivities(\''+dateStr+'\')">'
      +'<div class="acc-date'+(isToday?' today-date':'')+'">'+d2+'</div>'
      +chips+'</div>';
  }
  var totalCells=firstDay+daysInMonth;
  var remaining=(7-totalCells%7)%7;
  for(var n=1;n<=remaining;n++){
    cells+='<div class="act-cal-cell other-month"><div class="acc-date">'+n+'</div></div>';
  }
  document.getElementById('act-cal-grid').innerHTML=cells;
}
function openAddActivity(){
  document.getElementById('act-log-date').value=todayVal();
  document.getElementById('act-log-kw').value='';
  document.getElementById('act-log-notes').value='';
  document.getElementById('act-log-class').value='';
  document.getElementById('modal-activity').style.display='flex';
}
function openAddActivityForDate(dateStr){
  document.getElementById('act-log-date').value=dateStr;
  document.getElementById('act-log-kw').value='';
  document.getElementById('act-log-notes').value='';
  document.getElementById('act-log-class').value='';
  document.getElementById('modal-activity').style.display='flex';
}
function showDayActivities(dateStr){
  var activities=(window._actByDate&&window._actByDate[dateStr])||[];
  var panel=document.getElementById('act-detail-panel');
  if(!panel) return;
  var d=new Date(dateStr+'T00:00:00');
  var label=d.toLocaleDateString('en-IN',{weekday:'long',day:'numeric',month:'long'});
  var html='<div style="margin-bottom:10px;display:flex;align-items:center;justify-content:space-between">'
    +'<div><div style="font-size:13px;font-weight:700">'+label+'</div>'
    +'<div style="font-size:10px;color:#8A9E9B;margin-top:1px">'+activities.length+' activit'+(activities.length===1?'y':'ies')+'</div></div>'
    +'<button class="btn btn-primary btn-sm" onclick="openAddActivityForDate(\''+dateStr+'\')">+ Add</button>'
    +'</div>';
  if(!activities.length){
    html+='<p style="font-size:12px;color:#8A9E9B;padding:16px 0;text-align:center">No activities logged.<br>Click "+ Add" to log one.</p>';
  } else {
    html+=activities.map(function(a){
      var kw=(a.Keyword&&String(a.Keyword).trim())||(a.Tags&&String(a.Tags).trim())||'Activity';
      return '<div style="background:#F7F5F2;border-radius:9px;padding:10px 12px;margin-bottom:8px">'
        +'<div style="display:flex;align-items:center;gap:6px;margin-bottom:4px">'
        +'<span style="background:#E5F6F6;color:#2A9D9B;border-radius:5px;padding:2px 8px;font-size:11px;font-weight:700">'+kw+'</span>'
        +(a.Class?'<span style="font-size:10px;color:#8A9E9B">'+a.Class+'</span>':'')
        +'</div>'
        +(a.Notes?'<p style="font-size:12px;color:#1F3D3A;line-height:1.4;margin-top:4px">'+a.Notes+'</p>':'')
        +'</div>';
    }).join('');
  }
  document.getElementById('act-detail-content').innerHTML=html;
}
function saveActivity(){
  call('addActivity',{Date:document.getElementById('act-log-date').value,Class:document.getElementById('act-log-class').value,Keyword:document.getElementById('act-log-kw').value.trim(),Notes:document.getElementById('act-log-notes').value.trim()},function(err){
    if(err) return toast('Error: '+err);
    closeModal('modal-activity');toast('Activity logged ✓');S.cache.activity=null;loadActivityCalendar();
  });
}
function openEditActivity(logID, dateStr, kwEnc, notesEnc, classEnc){
  document.getElementById('act-log-date').value=dateStr;
  document.getElementById('act-log-kw').value=decodeURIComponent(kwEnc);
  document.getElementById('act-log-notes').value=decodeURIComponent(notesEnc);
  document.getElementById('act-log-class').value=decodeURIComponent(classEnc);
  document.getElementById('modal-activity').style.display='flex';
}

// ═══════════════════════════════
//  HOLIDAY LIST
// ═══════════════════════════════
function countWorkingDays(startStr, endStr){
  var start = new Date(startStr+'T00:00:00');
  var end = new Date(endStr+'T00:00:00');
  var count = 0;
  var cur = new Date(start);
  while(cur <= end){
    var dow = cur.getDay();
    if(dow !== 0 && dow !== 6) count++;
    cur.setDate(cur.getDate()+1);
  }
  return count;
}

function loadHolidays(){
  document.getElementById('holidays-loading').style.display='block';
  document.getElementById('holiday-table').style.display='none';

  call('getHolidays', {}, function(err, data){
    document.getElementById('holidays-loading').style.display='none';
    if(err){ toast('Error loading holidays: '+err); return; }

    S.holidays = (data||[]).map(function(r){
      return {
        HolidayID: r.HolidayID || '',
        Occasion:  r.Occasion || r.Name || '',
        StartDate: r.StartDate || r.Date || '',
        EndDate:   r.EndDate || r.Date || '',
        NoOfDays:  r.NoOfDays || 1,
        Days:      r.Days || ''
      };
    }).filter(function(r){ return r.Occasion; })
      .sort(function(a,b){
        function toSortKey(str){
          var s = String(str||'').trim();
          if(!s || s.toLowerCase().includes('as per') || s.toLowerCase().includes('mandate')) return '9999-99-99';
          var parts = s.split('.');
          if(parts.length === 3 && parts[2].length === 4){
            return parts[2] + '-' + parts[1].padStart(2,'0') + '-' + parts[0].padStart(2,'0');
          }
          return s;
        }
        return toSortKey(a.StartDate).localeCompare(toSortKey(b.StartDate));
      });

    renderHolidayTable();
  });
}

function parseHolidayDate(str){
  if(!str) return null;
  var s = String(str).trim();
  if(!s || s.toLowerCase().includes('as per') || s.toLowerCase().includes('order') || s.toLowerCase().includes('mandate')) return null;
  var dotParts = s.split('.');
  if(dotParts.length === 3 && dotParts[2].length === 4){
    var d = new Date(parseInt(dotParts[2]), parseInt(dotParts[1])-1, parseInt(dotParts[0]));
    if(!isNaN(d.getTime())) return d;
  }
  var d2 = new Date(s);
  if(!isNaN(d2.getTime())) return d2;
  return null;
}

function renderHolidayTable(){
  var tbody = document.getElementById('holiday-tbody');
  var today = new Date(); today.setHours(0,0,0,0);
  var rows = S.holidays;

  var pastDividerAdded = false;
  var upcomingDividerAdded = false;
  var html = '';

  var firstUpcomingIdx = -1;
  rows.forEach(function(r, i){
    var sd = parseHolidayDate(r.StartDate);
    if(sd && sd >= today && firstUpcomingIdx === -1) firstUpcomingIdx = i;
  });

  rows.forEach(function(r, i){
    var sd = parseHolidayDate(r.StartDate);
    var ed = parseHolidayDate(r.EndDate);
    var isPast = sd && sd < today;
    var isFlexible = !sd;

    var wdCount = '—';
    if(sd && ed){
      var wd = countWorkingDays(
        sd.getFullYear()+'-'+pad(sd.getMonth()+1)+'-'+pad(sd.getDate()),
        ed.getFullYear()+'-'+pad(ed.getMonth()+1)+'-'+pad(ed.getDate())
      );
      wdCount = wd;
    } else if(sd) {
      var wd2 = countWorkingDays(
        sd.getFullYear()+'-'+pad(sd.getMonth()+1)+'-'+pad(sd.getDate()),
        sd.getFullYear()+'-'+pad(sd.getMonth()+1)+'-'+pad(sd.getDate())
      );
      wdCount = wd2;
    } else if(r.NoOfDays) {
      wdCount = r.NoOfDays;
    }

    if(!pastDividerAdded && !isPast && !isFlexible){
      if(i>0){
        html += '<tr class="holiday-divider"><td colspan="4">⬆ Past Holidays</td></tr>';
        pastDividerAdded = true;
      }
      if(!upcomingDividerAdded){
        html += '<tr class="holiday-divider"><td colspan="4">🗓 Upcoming Holidays</td></tr>';
        upcomingDividerAdded = true;
      }
    }
    if(isFlexible && !upcomingDividerAdded){
      html += '<tr class="holiday-divider"><td colspan="4">📋 As Per Orders</td></tr>';
      upcomingDividerAdded = true;
    }

    var dateDisp = '—';
    if(sd && ed && sd.getTime() !== ed.getTime()){
      var startFmt = sd.getDate()+' '+monthAbbr(pad(sd.getMonth()+1));
      var endFmt = ed.getDate()+' '+monthAbbr(pad(ed.getMonth()+1))+' '+ed.getFullYear();
      dateDisp = startFmt+' – '+endFmt;
    } else if(sd){
      dateDisp = sd.getDate()+' '+monthAbbr(pad(sd.getMonth()+1))+' '+sd.getFullYear();
    } else {
      dateDisp = 'As per orders';
    }

    var dayDisp = r.Days || (sd ? ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][sd.getDay()] : '—');
    var rowCls = isPast ? 'holiday-past' : (isFlexible ? '' : 'holiday-upcoming');

    html += '<tr class="'+rowCls+'">'
      +'<td>'+dateDisp+'</td>'
      +'<td><span class="holiday-day-chip">'+dayDisp+'</span></td>'
      +'<td>'+(isPast?'':(!isFlexible?'<span class="holiday-upcoming-badge"></span>':''))+r.Occasion+'</td>'
      +'<td style="text-align:center"><span class="holiday-days-chip">'+wdCount+(wdCount!=='—'?'d':'')+'</span></td>'
      +'</tr>';
  });

  if(!html) html = '<tr><td colspan="4" style="padding:20px;color:#8A9E9B;text-align:center">No holidays found.</td></tr>';
  tbody.innerHTML = html;
  document.getElementById('holiday-table').style.display = 'table';
}

function saveHolidayPDF(){
  toast('Generating holiday PDF…');
  var schoolName = (S.settings&&S.settings.school_name)||'Tiny Detectives School';
  var today = new Date(); today.setHours(0,0,0,0);

  var tableRows = S.holidays.filter(function(r){
    var sd = parseHolidayDate(r.StartDate);
    return !sd || sd >= today;
  });

  var tableHTML = '<table class="hpdf-table"><thead><tr>'
    +'<th>Date</th><th>Day</th><th>Occasion</th><th class="days-col">Days (Mon-Fri)</th>'
    +'</tr></thead><tbody>';

  tableRows.forEach(function(r){
    var sd = parseHolidayDate(r.StartDate);
    var ed = parseHolidayDate(r.EndDate);
    var wdCount = '—';
    if(sd && ed){
      wdCount = countWorkingDays(
        sd.getFullYear()+'-'+pad(sd.getMonth()+1)+'-'+pad(sd.getDate()),
        ed.getFullYear()+'-'+pad(ed.getMonth()+1)+'-'+pad(ed.getDate())
      );
    } else if(sd){
      wdCount = countWorkingDays(
        sd.getFullYear()+'-'+pad(sd.getMonth()+1)+'-'+pad(sd.getDate()),
        sd.getFullYear()+'-'+pad(sd.getMonth()+1)+'-'+pad(sd.getDate())
      );
    } else if(r.NoOfDays){
      wdCount = r.NoOfDays;
    }
    var dateDisp = '—';
    if(sd && ed && sd.getTime()!==ed.getTime()){
      dateDisp = sd.getDate()+' '+monthAbbr(pad(sd.getMonth()+1))+' – '+ed.getDate()+' '+monthAbbr(pad(ed.getMonth()+1))+' '+ed.getFullYear();
    } else if(sd){
      dateDisp = sd.getDate()+' '+monthAbbr(pad(sd.getMonth()+1))+' '+sd.getFullYear();
    } else {
      dateDisp = 'As per orders';
    }
    var dayDisp = r.Days||(sd?['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][sd.getDay()]:'—');
    tableHTML += '<tr><td>'+dateDisp+'</td><td>'+dayDisp+'</td><td>'+r.Occasion+'</td><td class="days-col">'+wdCount+'</td></tr>';
  });
  tableHTML += '</tbody></table>';

  var totalWD = tableRows.reduce(function(sum,r){
    var sd = parseHolidayDate(r.StartDate);
    var ed = parseHolidayDate(r.EndDate);
    if(!sd) return sum + (Number(r.NoOfDays)||0);
    if(!ed) ed = sd;
    return sum + countWorkingDays(
      sd.getFullYear()+'-'+pad(sd.getMonth()+1)+'-'+pad(sd.getDate()),
      ed.getFullYear()+'-'+pad(ed.getMonth()+1)+'-'+pad(ed.getDate())
    );
  }, 0);

  var yr = new Date().getFullYear();
  document.getElementById('holiday-pdf-wrap').innerHTML =
    '<div class="hpdf-header">'
    +'<div><div class="hpdf-school">'+schoolName+'</div><div class="hpdf-sub">Holiday Calendar · Academic Year '+yr+'-'+(yr+1)+'</div></div>'
    +'<div class="hpdf-badge">🗓 HOLIDAYS<div class="hpdf-year">'+yr+'-'+(yr+1)+'</div></div>'
    +'</div>'
    + tableHTML
    +'<div class="hpdf-footer">Total upcoming working days off: <strong>'+totalWD+' days</strong> (Monday–Friday only, excluding Saturdays & Sundays) · Prepared for parents &amp; guardians · '+new Date().toLocaleDateString('en-IN',{day:'numeric',month:'long',year:'numeric'})+'</div>';

  var el = document.getElementById('holiday-pdf-wrap');
  html2canvas(el, {scale:2, useCORS:true, backgroundColor:'#fff', logging:false}).then(function(canvas){
    var link = document.createElement('a');
    link.download = 'Holiday_List_'+schoolName.replace(/\s+/g,'_')+'.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
    toast('Holiday list downloaded ✓');
  }).catch(function(err){ toast('Error: '+(err.message||err)); });
}

// ═══════════════════════════════
//  ATT TRACKER
// ═══════════════════════════════
function initAttTracker(){ loadAttTracker(); }
function attTrackerPrev(){
  S.attTrackerMonth--;
  if(S.attTrackerMonth<0){S.attTrackerMonth=11;S.attTrackerYear--;}
  loadAttTracker();
}
function attTrackerNext(){
  S.attTrackerMonth++;
  if(S.attTrackerMonth>11){S.attTrackerMonth=0;S.attTrackerYear++;}
  loadAttTracker();
}
function loadAttTracker(){
  var yr=S.attTrackerYear, mo=S.attTrackerMonth;
  var mns=['January','February','March','April','May','June','July','August','September','October','November','December'];
  document.getElementById('att-tracker-month-label').textContent=mns[mo]+' '+yr;
  var monthKey=yr+'-'+pad(mo+1);
  var cls=document.getElementById('att-tracker-class')?document.getElementById('att-tracker-class').value:'';
  document.getElementById('att-tracker-grid').innerHTML='<div class="loader">Loading…</div>';
  if(cls==='__teachers__'){
    call('getTeachers',{},function(err,teachers){
      if(err) return;
      call('getMonthTeacherAttendance',{month:monthKey},function(err2,attData){
        renderAttTracker(
          teachers.map(function(t){return {StudentID:t.TeacherID,Name:t.Name,Class:t.Class||'Teacher'};}),
          (attData||[]).map(function(a){return {StudentID:a.TeacherID,Date:a.Date,Status:a.Status};}),
          yr, mo
        );
      });
    });
  } else {
    call('getMonthAttendance',{month:monthKey},function(err,attData){
      call('getStudents',{},function(err2,students){
        if(err2) return;
        var active=students.filter(function(s){
          return s.Status==='Active'&&(!cls||s.Class===cls);
        });
        renderAttTracker(active, attData||[], yr, mo);
      });
    });
  }
}
function renderAttTracker(students, attData, yr, mo){
  if(!students.length){
    document.getElementById('att-tracker-grid').innerHTML='<p style="font-size:12px;color:#8A9E9B;padding:10px">No active students.</p>';
    return;
  }
  var daysInMonth=new Date(yr,mo+1,0).getDate();
  var todayStr2=todayVal();
  var lookup={};
  (attData||[]).forEach(function(a){
    lookup[a.StudentID+'_'+String(a.Date).substring(0,10)]=a.Status;
  });
  var dayAbbr=['S','M','T','W','T','F','S'];
  var hdr='<div class="att-grid-hdr name-hdr">Student</div>';
  for(var d=1;d<=daysInMonth;d++){
    var dow=new Date(yr,mo,d).getDay();
    hdr+='<div class="att-grid-hdr'+(dow===0?' sun':'')+'" style="font-size:9px;line-height:1.2">'+(d<10?'0'+d:''+d)+'<br><span style="font-weight:400;font-size:8px">'+dayAbbr[dow]+'</span></div>';
  }
  var rows='';
  students.sort(cmpName).forEach(function(s){
    rows+='<div class="att-grid-name" title="'+(s.Name || '')+'">'+(s.Name || '').split(' ').slice(0,2).join(' ')+'</div>';
    for(var d2=1;d2<=daysInMonth;d2++){
      var dStr=yr+'-'+pad(mo+1)+'-'+pad(d2);
      var dow2=new Date(yr,mo,d2).getDay();
      var status=lookup[s.StudentID+'_'+dStr];
      var cellCls='att-grid-cell', label='';
      if(dow2===0){ cellCls+=' off'; }
      else if(dStr>todayStr2){ cellCls+=' future'; }
      else if(status==='Present'){ cellCls+=' P'; label='P'; }
      else if(status==='Absent'){ cellCls+=' A'; label='A'; }
      rows+='<div class="'+cellCls+'">'+label+'</div>';
    }
  });
  var cols='140px repeat('+daysInMonth+',minmax(16px,1fr))';
  document.getElementById('att-tracker-grid').innerHTML=
    '<div style="overflow-x:auto"><div class="att-grid" style="grid-template-columns:'+cols+'">'+hdr+rows+'</div></div>';
}

// ═══════════════════════════════
//  SETTINGS
// ═══════════════════════════════
function loadSettings(){
  if(S.cache.settings && Object.keys(S.cache.settings).length){
    S.settings=S.cache.settings;
  } else {
    call('getSettings',{},function(err,d){ if(!err){ S.settings=d; S.cache.settings=d; } });
  }
}
function loadSettingsUI(){
  call('getSettings',{},function(err,d){
    if(err) return;
    S.settings=d;
    document.getElementById('fee_prenursery').value=d.fee_prenursery||1800;
    document.getElementById('fee_nursery').value=d.fee_nursery||2000;
    document.getElementById('fee_lkg').value=d.fee_lkg||2400;
    document.getElementById('camera_charge').value=d.camera_charge||500;
    document.getElementById('school_name').value=d.school_name||'';
    document.getElementById('school_addr1').value=d.school_addr1||'';
    document.getElementById('school_addr2').value=d.school_addr2||'';
  });
}
function saveSettings(){
  call('saveSettings',{
    fee_prenursery:document.getElementById('fee_prenursery').value,
    fee_nursery:document.getElementById('fee_nursery').value,
    fee_lkg:document.getElementById('fee_lkg').value,
    camera_charge:document.getElementById('camera_charge').value,
    school_name:document.getElementById('school_name').value,
    school_addr1:document.getElementById('school_addr1').value,
    school_addr2:document.getElementById('school_addr2').value
  },function(err){
    if(err) return toast('Error: '+err);
    loadSettings();toast('Settings saved ✓');
  });
}

function importMigrationData() {
  var fileInput = document.getElementById('migration-file-input');
  var file = fileInput ? fileInput.files[0] : null;
  if (!file) return toast('Please select a JSON file first');

  var reader = new FileReader();
  reader.onload = function(e) {
    try {
      var data = JSON.parse(e.target.result);
      toast('Importing data, please wait...');
      call('importData', { data: data }, function(err, stats) {
        if (err) {
          toast('Import failed: ' + err);
        } else {
          var details = 'Import summary:\n' +
            '• Students: ' + (stats.students || 0) + '\n' +
            '• Teachers: ' + (stats.teachers || 0) + '\n' +
            '• Holidays: ' + (stats.holidays || 0) + '\n' +
            '• Fees: ' + (stats.fees || 0) + '\n' +
            '• Attendance logs: ' + (stats.attendance || 0) + '\n' +
            '• Receipts: ' + (stats.feeReceipts || 0);
          alert('Data imported successfully! ✓\n\n' + details);
          softRefresh();
        }
      });
    } catch (err) {
      toast('Failed to parse JSON: ' + err.message);
    }
  };
  reader.readAsText(file);
}

// ═══════════════════════════════
//  EXPOSE BINDINGS FOR HTML HANDLERS
// ═══════════════════════════════
window.S = S;
window.selectStudent = selectStudent;
window.searchStudents = searchStudents;
window.filterStudents = filterStudents;
window.loadAttendance = loadAttendance;
window.loadFees = loadFees;
window.openEditActivity = openEditActivity;
window.showDayActivities = showDayActivities;
window.onReceiptStudentChange = onReceiptStudentChange;
window.importMigrationData = importMigrationData;
window.initApp = initApp;
window.toggleSidebar = toggleSidebar;
window.pinPress = pinPress;
window.showScreen = showScreen;
window.switchStaffTab = switchStaffTab;
window.softRefresh = softRefresh;
window.copyAttLink = copyAttLink;
window.loadDashboard = loadDashboard;
window.sendWaReminder = sendWaReminder;
window.openAddStudent = openAddStudent;
window.prefillFee = prefillFee;
window.openEditStudent = openEditStudent;
window.saveStudent = saveStudent;
window.handleModalPhotoUpload = handleModalPhotoUpload;
window.drawCroppedImage = drawCroppedImage;
window.rotateModalPhoto = rotateModalPhoto;
window.deleteModalPhoto = deleteModalPhoto;
window.selectStudent = selectStudent;
window.openPromote = openPromote;
window.openExitModal = openExitModal;
window.confirmExit = confirmExit;
window.updateFeeOverride = updateFeeOverride;
window.toggleCamera = toggleCamera;
window.openGenerateReceipt = openGenerateReceipt;
window.setAtt = setAtt;
window.saveAttendance = saveAttendance;
window.setFeeFilter = setFeeFilter;
window.openBulkMarkPaid = openBulkMarkPaid;
window.confirmMarkFeesBulkPaid = confirmMarkFeesBulkPaid;
window.generateFees = generateFees;
window.openMarkFeePaid = openMarkFeePaid;
window.confirmMarkFeePaid = confirmMarkFeePaid;
window.addReceiptItem = addReceiptItem;
window.removeRcpItem = removeRcpItem;
window.editRcpItemAmt = editRcpItemAmt;
window.triggerUpload = triggerUpload;
window.previewReceiptImg = previewReceiptImg;
window.addTextBox = addTextBox;
window.generateReceiptPDF = generateReceiptPDF;
window.saveReceiptToDB = saveReceiptToDB;
window.sendReceiptWhatsApp = sendReceiptWhatsApp;
window.openAddTeacher = openAddTeacher;
window.openEditTeacher = openEditTeacher;
window.saveTeacher = saveTeacher;
window.setTAtt = setTAtt;
window.saveTeacherAttendance = saveTeacherAttendance;
window.computeSalary = computeSalary;
window.markSalaryPaid = markSalaryPaid;
window.actCalPrev = actCalPrev;
window.actCalNext = actCalNext;
window.openAddActivity = openAddActivity;
window.openAddActivityForDate = openAddActivityForDate;
window.saveActivity = saveActivity;
window.saveHolidayPDF = saveHolidayPDF;
window.attTrackerPrev = attTrackerPrev;
window.attTrackerNext = attTrackerNext;
window.loadAttTracker = loadAttTracker;
window.saveSettings = saveSettings;
window.loadSettingsUI = loadSettingsUI;
window.closeModal = closeModal;
window.closeModalOutside = closeModalOutside;

function onWaReminderClick(btn) {
  var phone = btn.getAttribute('data-phone');
  var name = btn.getAttribute('data-name');
  var amount = btn.getAttribute('data-amount');
  sendWaReminder(phone, name, amount);
}

function onBulkMarkPaidClick(btn) {
  var ids = (btn.getAttribute('data-ids') || '').split(',');
  var name = btn.getAttribute('data-name');
  var total = btn.getAttribute('data-total');
  openBulkMarkPaid(ids, name, total);
}

window.onWaReminderClick = onWaReminderClick;
window.onBulkMarkPaidClick = onBulkMarkPaidClick;

// Start app PIN check logic immediately on load
document.addEventListener('DOMContentLoaded', function() {
  initCropDragging();
  window.addEventListener('resize', updateMobilePanelVisibility);

  // If the URL view parameter is 'attendance', bypass PIN for teacher attendance view
  var params = new URLSearchParams(window.location.search);
  if (params.get('view') === 'attendance') {
    document.getElementById('pin-screen').style.display = "none";
    document.getElementById('app').style.display = "flex";
    
    // Reroute to attendance screen directly and remove sidebar for clean look
    setTimeout(function() {
      showScreen('attendance');
      var sidebar = document.querySelector('.sidebar');
      if (sidebar) sidebar.style.display = 'none';
      var refresh = document.getElementById('refresh-btn');
      if (refresh) refresh.style.display = 'none';
    }, 100);
  }
});


// ═══════════════════════════════
//  ICARD GENERATOR MODULE
// ═══════════════════════════════
function openCreateICard(studentId) {
  const s = S.students.find(x => x.StudentID === studentId);
  if (!s) return;
  const photo = s.Photo || localStorage.getItem('td_icard_photo_' + studentId) || null;
  const cardData = {
    name: s.Name || '',
    id: s.StudentID || '',
    father: s.FatherGuardianName || '',
    mobile: s.Phone || '',
    dob: s.DOB || '',
    address: s.Address || '',
    photo: photo
  };
  
  document.getElementById('modal-icard-title').textContent = 'Create iCard - ' + cardData.name;
  document.getElementById('modal-icard-front').innerHTML = renderFront(cardData);
  document.getElementById('modal-icard-back').innerHTML = renderBack(cardData);
  
  const frontBtn = document.getElementById('btn-download-icard-front');
  const backBtn = document.getElementById('btn-download-icard-back');
  
  frontBtn.onclick = () => downloadICard('front', cardData);
  backBtn.onclick = () => downloadICard('back', cardData);
  
  document.getElementById('modal-icard').style.display = 'flex';
}

function downloadICard(side, s) {
  if (!s) return;
  toast('⏳ Generating 300 DPI PNG…');
  renderToCanvas(s, side).then(canvas => {
    canvas.toBlob(blob => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = (s.name.replace(/\s+/g,'_') || 'student') + '_' + side + '_ID_300dpi.png';
      document.body.appendChild(a);
      a.click();
      setTimeout(() => { URL.revokeObjectURL(url); document.body.removeChild(a); }, 1000);
      toast('✅ PNG saved to Downloads!');
    }, 'image/png');
  }).catch(err => {
    console.error(err);
    toast('❌ Export failed: ' + err.message);
  });
}

async function renderToCanvas(s, side) {
  const container = document.getElementById('hiresCanvasContainer');
  const wrapper = document.createElement('div');
  wrapper.style.cssText = 'width:252px;height:400px;position:absolute;left:0;top:0;overflow:hidden;border-radius:16px;font-family:Nunito,sans-serif;';
  wrapper.innerHTML = side === 'front' ? renderFront(s) : renderBack(s);
  container.innerHTML = '';
  container.appendChild(wrapper);
  const imgs = [...wrapper.querySelectorAll('img')];
  await Promise.all(imgs.map(img => new Promise(r => {
    if (img.complete && img.naturalWidth > 0) r();
    else { img.onload = r; img.onerror = r; }
  })));
  await new Promise(r => setTimeout(r, 250));
  const scale = 638 / 252;
  const canvas = await window.html2canvas(wrapper, {
    scale, useCORS: true, allowTaint: true,
    backgroundColor: '#7DD9E8', width: 252, height: 400,
    logging: false, imageTimeout: 0
  });
  container.innerHTML = '';
  return canvas;
}

function getBurstSVG() {
  const rays = [
    { color: '#e53e3e', angle: -55 }, { color: '#dd6b20', angle: -35 },
    { color: '#d69e2e', angle: -15 }, { color: '#38a169', angle: 5 },
    { color: '#3182ce', angle: 25 }, { color: '#805ad5', angle: 45 },
    { color: '#6b46c1', angle: 65 }
  ];
  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="126" height="126" viewBox="0 0 126 126">' + rays.map(r => {
    const rad = (r.angle - 90) * Math.PI / 180;
    const cx = 63, cy = 63, inner = 22, outer = 52;
    const x1 = cx + Math.cos(rad) * inner;
    const y1 = cy + Math.sin(rad) * inner;
    const x2 = cx + Math.cos(rad) * outer;
    const y2 = cy + Math.sin(rad) * outer;
    return '<line x1="' + x1.toFixed(1) + '" y1="' + y1.toFixed(1) + '" x2="' + x2.toFixed(1) + '" y2="' + y2.toFixed(1) + '" stroke="' + r.color + '" stroke-width="6" stroke-linecap="round"/>';
  }).join('') + '</svg>');
}

function calcFontSize(name) {
  const len = (name || '').length;
  if (len <= 12) return '24px';
  if (len <= 16) return '21px';
  if (len <= 20) return '18px';
  return '15px';
}

function renderFront(s) {
  const photoContent = s.photo
    ? '<img src="' + s.photo + '" style="width:100%;height:100%;object-fit:cover;object-position:center top;display:block;">'
    : '<div class="photo-placeholder"><div class="ph-icon">👤</div><div class="ph-txt">NO PHOTO</div></div>';
  
  const fs = calcFontSize(s.name);
  const idFs = parseInt(fs) > 18 ? '18px' : (parseInt(fs) - 2) + 'px';

  return '<div class="card-front">' +
    '<div class="logo-area">' +
      '<img class="logo-icon" src="' + ICON_SRC + '">' +
      '<img class="logo-text" src="' + TEXT_SRC + '">' +
    '</div>' +
    '<div class="photo-section">' +
      '<div class="burst-container">' +
        '<img class="burst-rays-img" src="' + getBurstSVG() + '" alt="">' +
        '<div class="photo-arch-wrap">' + photoContent + '</div>' +
      '</div>' +
    '</div>' +
    '<div class="name-area">' +
      '<div class="student-name" style="font-size:' + fs + '">' + (s.name || 'Student Name') + '</div>' +
      '<div class="student-id" style="font-size:' + idFs + '">ID NO. : ' + (s.id || '—') + '</div>' +
    '</div>' +
  '</div>';
}

function renderBack(s) {
  const addr = (S.settings.school_addr1 || '') + ' ' + (S.settings.school_addr2 || '');
  const SCHOOL_ADDRESS = addr.trim() || "Tower B, G1, Coco County, Sector 10, Gr Noida West";

  return '<div class="card-back">' +
    '<div class="logo-area">' +
      '<img class="logo-icon" src="' + ICON_SRC + '">' +
      '<img class="logo-text" src="' + TEXT_SRC + '">' +
    '</div>' +
    '<div class="details-section">' +
      '<div class="detail-row"><span class="detail-label">Student\'s Name</span><span class="detail-colon">:</span><span class="detail-value">' + (s.name||'—') + '</span></div>' +
      '<div class="detail-row"><span class="detail-label">Father\'s Name</span><span class="detail-colon">:</span><span class="detail-value">' + (s.father||'—') + '</span></div>' +
      '<div class="detail-row"><span class="detail-label">Mobile</span><span class="detail-colon">:</span><span class="detail-value">' + (s.mobile||'—') + '</span></div>' +
      '<div class="detail-row"><span class="detail-label">DOB</span><span class="detail-colon">:</span><span class="detail-value">' + (s.dob||'—') + '</span></div>' +
      '<div class="detail-row"><span class="detail-label">Address</span><span class="detail-colon">:</span><span class="detail-value">' + (s.address||'—') + '</span></div>' +
    '</div>' +
    '<div class="card-back-divider"></div>' +
    '<div class="school-address">' +
      '<div class="school-address-text">📍 ' + SCHOOL_ADDRESS + '</div>' +
    '</div>' +
    '<div class="terms-section">' +
      '<div class="term-item"><span class="term-bullet">•</span><span class="term-text">In case lost, duplicate card will be issued and replacement fee may apply</span></div>' +
      '<div class="term-item"><span class="term-bullet">•</span><span class="term-text">The card is non-transferable.</span></div>' +
    '</div>' +
    '<div class="principal-text">PRINCIPAL</div>' +
  '</div>';
}

window.openCreateICard = openCreateICard;
window.downloadICard = downloadICard;

